//-----Types.File-----
export interface ProblemDetails  {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}
export function deserializeProblemDetails(json: string): ProblemDetails {
  const data = JSON.parse(json) as ProblemDetails;
  initProblemDetails(data);
  return data;
}
export function initProblemDetails(_data: ProblemDetails) {
    return _data;
}
export function serializeProblemDetails(_data: ProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeProblemDetails(_data as ProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProblemDetails(_data: ProblemDetails): ProblemDetails {
  const data: Record<string, any> = { ..._data };
  return data as ProblemDetails;
}
export interface HttpValidationProblemDetails extends ProblemDetails  {
  errors: { [key: string]: string[]; };
  [key: string]: any;
}
export function deserializeHttpValidationProblemDetails(json: string): HttpValidationProblemDetails {
  const data = JSON.parse(json) as HttpValidationProblemDetails;
  initHttpValidationProblemDetails(data);
  return data;
}
export function initHttpValidationProblemDetails(_data: HttpValidationProblemDetails) {
  initProblemDetails(_data);
    return _data;
}
export function serializeHttpValidationProblemDetails(_data: HttpValidationProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeHttpValidationProblemDetails(_data as HttpValidationProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHttpValidationProblemDetails(_data: HttpValidationProblemDetails): HttpValidationProblemDetails {
  const data = prepareSerializeProblemDetails(_data as HttpValidationProblemDetails) as Record<string, any>;
  return data as HttpValidationProblemDetails;
}
export interface ValidationProblemDetails extends HttpValidationProblemDetails  {
  errors: { [key: string]: string[]; };
  [key: string]: any;
}
export function deserializeValidationProblemDetails(json: string): ValidationProblemDetails {
  const data = JSON.parse(json) as ValidationProblemDetails;
  initValidationProblemDetails(data);
  return data;
}
export function initValidationProblemDetails(_data: ValidationProblemDetails) {
  initHttpValidationProblemDetails(_data);
    return _data;
}
export function serializeValidationProblemDetails(_data: ValidationProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeValidationProblemDetails(_data as ValidationProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeValidationProblemDetails(_data: ValidationProblemDetails): ValidationProblemDetails {
  const data = prepareSerializeHttpValidationProblemDetails(_data as ValidationProblemDetails) as Record<string, any>;
  return data as ValidationProblemDetails;
}
export interface WarrantyResponseDto  {
  deviceType: DeviceType;
  table: AbasErpDataTableItem[] | null;
  totalTableRowCount: number | null;
  foundDevice: FoundDeviceDto | null;
}
export function deserializeWarrantyResponseDto(json: string): WarrantyResponseDto {
  const data = JSON.parse(json) as WarrantyResponseDto;
  initWarrantyResponseDto(data);
  return data;
}
export function initWarrantyResponseDto(_data: WarrantyResponseDto) {
  if (_data) {
    _data.deviceType = _data["deviceType"];
    if (Array.isArray(_data["table"])) {
      _data.table = _data["table"].map(item => 
        initAbasErpDataTableItem(item)
      );
    }
    _data.foundDevice = _data["foundDevice"] && initFoundDeviceDto(_data["foundDevice"]);
  }
  return _data;
}
export function serializeWarrantyResponseDto(_data: WarrantyResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeWarrantyResponseDto(_data as WarrantyResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeWarrantyResponseDto(_data: WarrantyResponseDto): WarrantyResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.table)) {
    data["table"] = _data.table.map(item => 
        prepareSerializeAbasErpDataTableItem(item)
    );
  }
  data["foundDevice"] = _data.foundDevice && prepareSerializeFoundDeviceDto(_data.foundDevice);
  return data as WarrantyResponseDto;
}
export enum DeviceType {
    Default = "Default",
    Special = "Special",
    WithMultipleSerialNumber = "WithMultipleSerialNumber",
}
export interface AbasErpDataTableItem  {
  fields: { [key: string]: QueryResponseField; };
  number: number;
}
export function deserializeAbasErpDataTableItem(json: string): AbasErpDataTableItem {
  const data = JSON.parse(json) as AbasErpDataTableItem;
  initAbasErpDataTableItem(data);
  return data;
}
export function initAbasErpDataTableItem(_data: AbasErpDataTableItem) {
    return _data;
}
export function serializeAbasErpDataTableItem(_data: AbasErpDataTableItem | undefined) {
  if (_data) {
    _data = prepareSerializeAbasErpDataTableItem(_data as AbasErpDataTableItem);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasErpDataTableItem(_data: AbasErpDataTableItem): AbasErpDataTableItem {
  const data: Record<string, any> = { ..._data };
  if (_data.fields) {
    for (let key in _data.fields) {
            (<any>data["fields"])[key] = _data.fields[key] && prepareSerializeQueryResponseField(_data.fields[key]);
    }
}
  return data as AbasErpDataTableItem;
}
export interface QueryResponseField  {
  text: string | null;
  /** string or number or bool */
  value: any | null;
  links: { [key: string]: AbasQueryLink[]; } | null;
}
export function deserializeQueryResponseField(json: string): QueryResponseField {
  const data = JSON.parse(json) as QueryResponseField;
  initQueryResponseField(data);
  return data;
}
export function initQueryResponseField(_data: QueryResponseField) {
  if (_data) {
    _data.value = _data["value"];
  }
  return _data;
}
export function serializeQueryResponseField(_data: QueryResponseField | undefined) {
  if (_data) {
    _data = prepareSerializeQueryResponseField(_data as QueryResponseField);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeQueryResponseField(_data: QueryResponseField): QueryResponseField {
  const data: Record<string, any> = { ..._data };
  return data as QueryResponseField;
}
export interface AbasQueryLink  {
  description: string;
  rel: string;
  href: string;
  objectType: string;
}
export function deserializeAbasQueryLink(json: string): AbasQueryLink {
  const data = JSON.parse(json) as AbasQueryLink;
  initAbasQueryLink(data);
  return data;
}
export function initAbasQueryLink(_data: AbasQueryLink) {
    return _data;
}
export function serializeAbasQueryLink(_data: AbasQueryLink | undefined) {
  if (_data) {
    _data = prepareSerializeAbasQueryLink(_data as AbasQueryLink);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasQueryLink(_data: AbasQueryLink): AbasQueryLink {
  const data: Record<string, any> = { ..._data };
  return data as AbasQueryLink;
}
export interface FoundDeviceDto  {
  /** Selected serial number (serviceprodukt) */
  serialNumber: string;
  /** Device name (serprodname) */
  deviceName: string;
  /** Design year (ybj) */
  manufactureYear: string;
  availableErrors: { [key: string]: string; } | null;
}
export function deserializeFoundDeviceDto(json: string): FoundDeviceDto {
  const data = JSON.parse(json) as FoundDeviceDto;
  initFoundDeviceDto(data);
  return data;
}
export function initFoundDeviceDto(_data: FoundDeviceDto) {
    return _data;
}
export function serializeFoundDeviceDto(_data: FoundDeviceDto | undefined) {
  if (_data) {
    _data = prepareSerializeFoundDeviceDto(_data as FoundDeviceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFoundDeviceDto(_data: FoundDeviceDto): FoundDeviceDto {
  const data: Record<string, any> = { ..._data };
  return data as FoundDeviceDto;
}
export enum SortOrder {
    Asc = "Asc",
    Desc = "Desc",
}
export interface ReplacementPartResponseDto  {
  /** replacement part article (tersatzteil) */
  replacementPartArticle: string | null;
  /** Description of the spare part (device name) (ersatzbez) */
  sparePartDescription: string | null;
}
export function deserializeReplacementPartResponseDto(json: string): ReplacementPartResponseDto {
  const data = JSON.parse(json) as ReplacementPartResponseDto;
  initReplacementPartResponseDto(data);
  return data;
}
export function initReplacementPartResponseDto(_data: ReplacementPartResponseDto) {
    return _data;
}
export function serializeReplacementPartResponseDto(_data: ReplacementPartResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeReplacementPartResponseDto(_data as ReplacementPartResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeReplacementPartResponseDto(_data: ReplacementPartResponseDto): ReplacementPartResponseDto {
  const data: Record<string, any> = { ..._data };
  return data as ReplacementPartResponseDto;
}
/** Using when we want to add prisma or default device to basket (without choosing failure during therapy) */
export interface FillDefaultWarrantyRequestDto  {
  /** Serial number (seriennummer)
             */
  serialNumber: string;
  /** Operating hours (yibetrstd) */
  operatingHours: number | null;
  /** Resale date (weivkdat) */
  resaleDate: Date | null;
  /** Replacement part article (tersatzteil) */
  replacementPartArticle: string | null;
  /** Replacement part serial number (ersatzsernum) */
  replacementPartSerialNumber: string | null;
  /** Additional error description (fehlertext) */
  additionalErrorDescription: string | null;
  /** List that contains device errors (bfa1, bfa2...etc) */
  selectedErrors: string[];
}
export function deserializeFillDefaultWarrantyRequestDto(json: string): FillDefaultWarrantyRequestDto {
  const data = JSON.parse(json) as FillDefaultWarrantyRequestDto;
  initFillDefaultWarrantyRequestDto(data);
  return data;
}
export function initFillDefaultWarrantyRequestDto(_data: FillDefaultWarrantyRequestDto) {
  if (_data) {
    _data.resaleDate = _data["resaleDate"] ? new Date(_data["resaleDate"].toString()) : <any>null;
    _data.selectedErrors = _data["selectedErrors"];
  }
  return _data;
}
export function serializeFillDefaultWarrantyRequestDto(_data: FillDefaultWarrantyRequestDto | undefined) {
  if (_data) {
    _data = prepareSerializeFillDefaultWarrantyRequestDto(_data as FillDefaultWarrantyRequestDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFillDefaultWarrantyRequestDto(_data: FillDefaultWarrantyRequestDto): FillDefaultWarrantyRequestDto {
  const data: Record<string, any> = { ..._data };
  data["resaleDate"] = _data.resaleDate && _data.resaleDate.toISOString();
  return data as FillDefaultWarrantyRequestDto;
}
export interface FillWarrantyRequestSameNumDto  {
  /** Service product (serviceprodukt) */
  serviceProduct: string;
  /** Operating hours (yibetrstd) */
  operatingHours: number | null;
  /** Resale date (weivkdat) */
  resaleDate: Date | null;
  /** Replacement part article (tersatzteil) */
  replacementPartArticle: string | null;
  /** Replacement part serial number (ersatzsernum) */
  replacementPartSerialNumber: string | null;
  /** Additional error description (fehlertext) */
  additionalErrorDescription: string | null;
  /** List that contains device errors (bfa1, bfa2...etc) */
  selectedErrors: string[];
}
export function deserializeFillWarrantyRequestSameNumDto(json: string): FillWarrantyRequestSameNumDto {
  const data = JSON.parse(json) as FillWarrantyRequestSameNumDto;
  initFillWarrantyRequestSameNumDto(data);
  return data;
}
export function initFillWarrantyRequestSameNumDto(_data: FillWarrantyRequestSameNumDto) {
  if (_data) {
    _data.resaleDate = _data["resaleDate"] ? parseDateOnly(_data["resaleDate"].toString()) : <any>null;
    _data.selectedErrors = _data["selectedErrors"];
  }
  return _data;
}
export function serializeFillWarrantyRequestSameNumDto(_data: FillWarrantyRequestSameNumDto | undefined) {
  if (_data) {
    _data = prepareSerializeFillWarrantyRequestSameNumDto(_data as FillWarrantyRequestSameNumDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFillWarrantyRequestSameNumDto(_data: FillWarrantyRequestSameNumDto): FillWarrantyRequestSameNumDto {
  const data: Record<string, any> = { ..._data };
  data["resaleDate"] = _data.resaleDate && formatDate(_data.resaleDate);
  return data as FillWarrantyRequestSameNumDto;
}
/** Special device differs from default by adding fields "failure during therapy" */
export interface FillSpecialWarrantyRequestDto extends FillDefaultWarrantyRequestDto  {
  /** Failure during therapy (kybausfther) */
  failureDuringTherapy: boolean;
  /** No failure during therapy (kybnausfther) */
  noFailureDuringTherapy: boolean;
}
export function deserializeFillSpecialWarrantyRequestDto(json: string): FillSpecialWarrantyRequestDto {
  const data = JSON.parse(json) as FillSpecialWarrantyRequestDto;
  initFillSpecialWarrantyRequestDto(data);
  return data;
}
export function initFillSpecialWarrantyRequestDto(_data: FillSpecialWarrantyRequestDto) {
  initFillDefaultWarrantyRequestDto(_data);
    return _data;
}
export function serializeFillSpecialWarrantyRequestDto(_data: FillSpecialWarrantyRequestDto | undefined) {
  if (_data) {
    _data = prepareSerializeFillSpecialWarrantyRequestDto(_data as FillSpecialWarrantyRequestDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFillSpecialWarrantyRequestDto(_data: FillSpecialWarrantyRequestDto): FillSpecialWarrantyRequestDto {
  const data = prepareSerializeFillDefaultWarrantyRequestDto(_data as FillSpecialWarrantyRequestDto) as Record<string, any>;
  return data as FillSpecialWarrantyRequestDto;
}
export interface WarrantyRequestSummaryResponseDto  {
  countOfRecords: number;
  records: WarrantyRequestOrder[];
}
export function deserializeWarrantyRequestSummaryResponseDto(json: string): WarrantyRequestSummaryResponseDto {
  const data = JSON.parse(json) as WarrantyRequestSummaryResponseDto;
  initWarrantyRequestSummaryResponseDto(data);
  return data;
}
export function initWarrantyRequestSummaryResponseDto(_data: WarrantyRequestSummaryResponseDto) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initWarrantyRequestOrder(item)
      );
    }
  }
  return _data;
}
export function serializeWarrantyRequestSummaryResponseDto(_data: WarrantyRequestSummaryResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeWarrantyRequestSummaryResponseDto(_data as WarrantyRequestSummaryResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeWarrantyRequestSummaryResponseDto(_data: WarrantyRequestSummaryResponseDto): WarrantyRequestSummaryResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeWarrantyRequestOrder(item)
    );
  }
  return data as WarrantyRequestSummaryResponseDto;
}
export interface WarrantyRequestOrder  {
  orderNumber: string;
  from: Date | null;
  reference: string;
  order: string;
  requests: WarrantyRequestDevice[];
}
export function deserializeWarrantyRequestOrder(json: string): WarrantyRequestOrder {
  const data = JSON.parse(json) as WarrantyRequestOrder;
  initWarrantyRequestOrder(data);
  return data;
}
export function initWarrantyRequestOrder(_data: WarrantyRequestOrder) {
  if (_data) {
    _data.from = _data["from"] ? parseDateOnly(_data["from"].toString()) : <any>null;
    if (Array.isArray(_data["requests"])) {
      _data.requests = _data["requests"].map(item => 
        initWarrantyRequestDevice(item)
      );
    }
  }
  return _data;
}
export function serializeWarrantyRequestOrder(_data: WarrantyRequestOrder | undefined) {
  if (_data) {
    _data = prepareSerializeWarrantyRequestOrder(_data as WarrantyRequestOrder);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeWarrantyRequestOrder(_data: WarrantyRequestOrder): WarrantyRequestOrder {
  const data: Record<string, any> = { ..._data };
  data["from"] = _data.from && formatDate(_data.from);
  if (Array.isArray(_data.requests)) {
    data["requests"] = _data.requests.map(item => 
        prepareSerializeWarrantyRequestDevice(item)
    );
  }
  return data as WarrantyRequestOrder;
}
export interface WarrantyRequestDevice  {
  serialNumber: string;
  name: string;
  article: string;
  parts: WarrantyRequestPart[];
}
export function deserializeWarrantyRequestDevice(json: string): WarrantyRequestDevice {
  const data = JSON.parse(json) as WarrantyRequestDevice;
  initWarrantyRequestDevice(data);
  return data;
}
export function initWarrantyRequestDevice(_data: WarrantyRequestDevice) {
  if (_data) {
    if (Array.isArray(_data["parts"])) {
      _data.parts = _data["parts"].map(item => 
        initWarrantyRequestPart(item)
      );
    }
  }
  return _data;
}
export function serializeWarrantyRequestDevice(_data: WarrantyRequestDevice | undefined) {
  if (_data) {
    _data = prepareSerializeWarrantyRequestDevice(_data as WarrantyRequestDevice);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeWarrantyRequestDevice(_data: WarrantyRequestDevice): WarrantyRequestDevice {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.parts)) {
    data["parts"] = _data.parts.map(item => 
        prepareSerializeWarrantyRequestPart(item)
    );
  }
  return data as WarrantyRequestDevice;
}
export interface WarrantyRequestPart  {
  name: string;
  article: string;
  deliveryDate: Date | null;
  garantie: string;
}
export function deserializeWarrantyRequestPart(json: string): WarrantyRequestPart {
  const data = JSON.parse(json) as WarrantyRequestPart;
  initWarrantyRequestPart(data);
  return data;
}
export function initWarrantyRequestPart(_data: WarrantyRequestPart) {
  if (_data) {
    _data.deliveryDate = _data["deliveryDate"] ? parseDateOnly(_data["deliveryDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeWarrantyRequestPart(_data: WarrantyRequestPart | undefined) {
  if (_data) {
    _data = prepareSerializeWarrantyRequestPart(_data as WarrantyRequestPart);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeWarrantyRequestPart(_data: WarrantyRequestPart): WarrantyRequestPart {
  const data: Record<string, any> = { ..._data };
  data["deliveryDate"] = _data.deliveryDate && formatDate(_data.deliveryDate);
  return data as WarrantyRequestPart;
}
export interface BasketGetResponseDto  {
  records: BasketRecord[];
  mailStandard: string | null;
  countOfRecords: number;
}
export function deserializeBasketGetResponseDto(json: string): BasketGetResponseDto {
  const data = JSON.parse(json) as BasketGetResponseDto;
  initBasketGetResponseDto(data);
  return data;
}
export function initBasketGetResponseDto(_data: BasketGetResponseDto) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initBasketRecord(item)
      );
    }
  }
  return _data;
}
export function serializeBasketGetResponseDto(_data: BasketGetResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeBasketGetResponseDto(_data as BasketGetResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeBasketGetResponseDto(_data: BasketGetResponseDto): BasketGetResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeBasketRecord(item)
    );
  }
  return data as BasketGetResponseDto;
}
export interface BasketRecord  {
  serialNumber: string;
  productId: string;
  name: string | null;
  parts: BasketPart[];
}
export function deserializeBasketRecord(json: string): BasketRecord {
  const data = JSON.parse(json) as BasketRecord;
  initBasketRecord(data);
  return data;
}
export function initBasketRecord(_data: BasketRecord) {
  if (_data) {
    if (Array.isArray(_data["parts"])) {
      _data.parts = _data["parts"].map(item => 
        initBasketPart(item)
      );
    }
  }
  return _data;
}
export function serializeBasketRecord(_data: BasketRecord | undefined) {
  if (_data) {
    _data = prepareSerializeBasketRecord(_data as BasketRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeBasketRecord(_data: BasketRecord): BasketRecord {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.parts)) {
    data["parts"] = _data.parts.map(item => 
        prepareSerializeBasketPart(item)
    );
  }
  return data as BasketRecord;
}
export interface BasketPart  {
  name: string;
  article: string;
  itemId: string;
}
export function deserializeBasketPart(json: string): BasketPart {
  const data = JSON.parse(json) as BasketPart;
  initBasketPart(data);
  return data;
}
export function initBasketPart(_data: BasketPart) {
    return _data;
}
export function serializeBasketPart(_data: BasketPart | undefined) {
  if (_data) {
    _data = prepareSerializeBasketPart(_data as BasketPart);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeBasketPart(_data: BasketPart): BasketPart {
  const data: Record<string, any> = { ..._data };
  return data as BasketPart;
}
export interface BasketCertainOrderResponseDto  {
  /** Service product name (yserviceprodukt text) */
  serviceProductName: string | null;
  /** Service product id (yserviceprodukt value) */
  serviceProductId: string | null;
  /** Operating hours (yibetrstd) */
  operatingHours: number | null;
  /** Resale date (yweivkdat) */
  resaleDate: Date | null;
  /** Replacement part article (yersatzteil) */
  replacementPartArticle: string | null;
  /** Replacement part serial number (yersatzsernum) */
  replacementPartSerialNumber: string | null;
  /** Additional error description (yfehlertext) */
  additionalErrorDescription: string | null;
  /** List that contains device errors (ybfa1, ybfa2...etc) */
  availableErrors: { [key: string]: string; } | null;
  /** List that contains device errors (ybfa1, ybfa2...etc) */
  selectedErrors: { [key: string]: string; } | null;
  /** Failure during therapy (ybausfther) */
  failureDuringTherapy: boolean;
  /** No failure during therapy (ybnausfther) */
  noFailureDuringTherapy: boolean;
}
export function deserializeBasketCertainOrderResponseDto(json: string): BasketCertainOrderResponseDto {
  const data = JSON.parse(json) as BasketCertainOrderResponseDto;
  initBasketCertainOrderResponseDto(data);
  return data;
}
export function initBasketCertainOrderResponseDto(_data: BasketCertainOrderResponseDto) {
  if (_data) {
    _data.resaleDate = _data["resaleDate"] ? parseDateOnly(_data["resaleDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeBasketCertainOrderResponseDto(_data: BasketCertainOrderResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeBasketCertainOrderResponseDto(_data as BasketCertainOrderResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeBasketCertainOrderResponseDto(_data: BasketCertainOrderResponseDto): BasketCertainOrderResponseDto {
  const data: Record<string, any> = { ..._data };
  data["resaleDate"] = _data.resaleDate && formatDate(_data.resaleDate);
  return data as BasketCertainOrderResponseDto;
}
export interface BasketPatchOrderDto  {
  /** Service product (serviceprodukt) */
  serviceProduct: string;
  /** Replacement part serial number (ersatzsernum) */
  replacementPartSerialNumber: string | null;
  /** Replacement part article (tersatzteil) */
  replacementPartArticle: string | null;
  /** Operating hours (yibetrstd) */
  operatingHours: number | null;
  /** Resale date (weivkdat) */
  resaleDate: Date | null;
  /** Additional error description (fehlertext) */
  additionalErrorDescription: string | null;
  /** List that contains device errors (bfa1, bfa2...etc) */
  selectedErrors: string[];
  /** Failure during therapy (kybausfther) */
  failureDuringTherapy: boolean | null;
  /** No failure during therapy (kybnausfther) */
  noFailureDuringTherapy: boolean | null;
}
export function deserializeBasketPatchOrderDto(json: string): BasketPatchOrderDto {
  const data = JSON.parse(json) as BasketPatchOrderDto;
  initBasketPatchOrderDto(data);
  return data;
}
export function initBasketPatchOrderDto(_data: BasketPatchOrderDto) {
  if (_data) {
    _data.resaleDate = _data["resaleDate"] ? parseDateOnly(_data["resaleDate"].toString()) : <any>null;
    _data.selectedErrors = _data["selectedErrors"];
  }
  return _data;
}
export function serializeBasketPatchOrderDto(_data: BasketPatchOrderDto | undefined) {
  if (_data) {
    _data = prepareSerializeBasketPatchOrderDto(_data as BasketPatchOrderDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeBasketPatchOrderDto(_data: BasketPatchOrderDto): BasketPatchOrderDto {
  const data: Record<string, any> = { ..._data };
  data["resaleDate"] = _data.resaleDate && formatDate(_data.resaleDate);
  return data as BasketPatchOrderDto;
}
export interface BasketPatchOrderStatusDto  {
  /** Number of the certain order item (epos) */
  itemNumber: string;
  /** Stored(true) or not stored(false) (ystorno) */
  isStored: boolean;
}
export function deserializeBasketPatchOrderStatusDto(json: string): BasketPatchOrderStatusDto {
  const data = JSON.parse(json) as BasketPatchOrderStatusDto;
  initBasketPatchOrderStatusDto(data);
  return data;
}
export function initBasketPatchOrderStatusDto(_data: BasketPatchOrderStatusDto) {
    return _data;
}
export function serializeBasketPatchOrderStatusDto(_data: BasketPatchOrderStatusDto | undefined) {
  if (_data) {
    _data = prepareSerializeBasketPatchOrderStatusDto(_data as BasketPatchOrderStatusDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeBasketPatchOrderStatusDto(_data: BasketPatchOrderStatusDto): BasketPatchOrderStatusDto {
  const data: Record<string, any> = { ..._data };
  return data as BasketPatchOrderStatusDto;
}
export interface SameDeviceResponseDto  {
  /** Service product id (yserviceprodukt value) */
  serviceProductId: string | null;
  /** Operating hours (yibetrstd) */
  operatingHours: number | null;
  /** Resale date (yweivkdat) */
  resaleDate: Date | null;
  deviceType: DeviceType;
}
export function deserializeSameDeviceResponseDto(json: string): SameDeviceResponseDto {
  const data = JSON.parse(json) as SameDeviceResponseDto;
  initSameDeviceResponseDto(data);
  return data;
}
export function initSameDeviceResponseDto(_data: SameDeviceResponseDto) {
  if (_data) {
    _data.resaleDate = _data["resaleDate"] ? parseDateOnly(_data["resaleDate"].toString()) : <any>null;
    _data.deviceType = _data["deviceType"];
  }
  return _data;
}
export function serializeSameDeviceResponseDto(_data: SameDeviceResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeSameDeviceResponseDto(_data as SameDeviceResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSameDeviceResponseDto(_data: SameDeviceResponseDto): SameDeviceResponseDto {
  const data: Record<string, any> = { ..._data };
  data["resaleDate"] = _data.resaleDate && formatDate(_data.resaleDate);
  return data as SameDeviceResponseDto;
}
export interface PagedResultOfUserListItemDto  {
  data: UserListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfUserListItemDto(json: string): PagedResultOfUserListItemDto {
  const data = JSON.parse(json) as PagedResultOfUserListItemDto;
  initPagedResultOfUserListItemDto(data);
  return data;
}
export function initPagedResultOfUserListItemDto(_data: PagedResultOfUserListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initUserListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfUserListItemDto(_data: PagedResultOfUserListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfUserListItemDto(_data as PagedResultOfUserListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfUserListItemDto(_data: PagedResultOfUserListItemDto): PagedResultOfUserListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeUserListItemDto(item)
    );
  }
  return data as PagedResultOfUserListItemDto;
}
export interface UserListItemDto  {
  id: string;
  userName: string;
  customerNumber: string;
  name: string;
  email: string;
  countryCode: string;
  createdAt: Date;
  lastSeenAt: Date | null;
  claimRoles: string[];
  isLocked: boolean;
}
export function deserializeUserListItemDto(json: string): UserListItemDto {
  const data = JSON.parse(json) as UserListItemDto;
  initUserListItemDto(data);
  return data;
}
export function initUserListItemDto(_data: UserListItemDto) {
  if (_data) {
    _data.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
    _data.lastSeenAt = _data["lastSeenAt"] ? new Date(_data["lastSeenAt"].toString()) : <any>null;
    _data.claimRoles = _data["claimRoles"];
  }
  return _data;
}
export function serializeUserListItemDto(_data: UserListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeUserListItemDto(_data as UserListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUserListItemDto(_data: UserListItemDto): UserListItemDto {
  const data: Record<string, any> = { ..._data };
  data["createdAt"] = _data.createdAt && _data.createdAt.toISOString();
  data["lastSeenAt"] = _data.lastSeenAt && _data.lastSeenAt.toISOString();
  return data as UserListItemDto;
}
export interface CreateNewUserRequestDto  {
  userName: string;
  /** Abas web user ident number (e.g. "25631") */
  webUserId: string;
  /** Abas customer number (e.g. "18813") */
  customerNumber: string;
  realName: string;
  email: string;
  countryCode: string;
  roles: string[];
  sendEmail: boolean;
}
export function deserializeCreateNewUserRequestDto(json: string): CreateNewUserRequestDto {
  const data = JSON.parse(json) as CreateNewUserRequestDto;
  initCreateNewUserRequestDto(data);
  return data;
}
export function initCreateNewUserRequestDto(_data: CreateNewUserRequestDto) {
  if (_data) {
    _data.roles = _data["roles"];
  }
  return _data;
}
export function serializeCreateNewUserRequestDto(_data: CreateNewUserRequestDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateNewUserRequestDto(_data as CreateNewUserRequestDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateNewUserRequestDto(_data: CreateNewUserRequestDto): CreateNewUserRequestDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateNewUserRequestDto;
}
export interface UserEnumRolesDto  {
  id: string;
  userName: string;
  firstName: string;
  lastName: string;
  customerNumber: string;
  country: string;
  email: string | null;
  claimRoles: UserRole[];
  isLocked: boolean;
  options: UserOptionsDto | null;
  features: UserFeatureFlagsDto;
}
export function deserializeUserEnumRolesDto(json: string): UserEnumRolesDto {
  const data = JSON.parse(json) as UserEnumRolesDto;
  initUserEnumRolesDto(data);
  return data;
}
export function initUserEnumRolesDto(_data: UserEnumRolesDto) {
  if (_data) {
    _data.claimRoles = _data["claimRoles"];
    _data.options = _data["options"] && initUserOptionsDto(_data["options"]);
    _data.features = _data["features"] && initUserFeatureFlagsDto(_data["features"]);
  }
  return _data;
}
export function serializeUserEnumRolesDto(_data: UserEnumRolesDto | undefined) {
  if (_data) {
    _data = prepareSerializeUserEnumRolesDto(_data as UserEnumRolesDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUserEnumRolesDto(_data: UserEnumRolesDto): UserEnumRolesDto {
  const data: Record<string, any> = { ..._data };
  data["options"] = _data.options && prepareSerializeUserOptionsDto(_data.options);
  data["features"] = _data.features && prepareSerializeUserFeatureFlagsDto(_data.features);
  return data as UserEnumRolesDto;
}
export enum UserRole {
    Admin = "Admin",
    Supplier = "Supplier",
    Customer = "Customer",
    Garantie = "Garantie",
    Standard = "Standard",
    Techniker = "Techniker",
    Techniker2 = "Techniker2",
    TechnikerE = "TechnikerE",
    Toechter = "Toechter",
    HaendlerDe = "HaendlerDe",
    HaendlerEk = "HaendlerEk",
    SemiAdmin = "SemiAdmin",
    SoftwareAccess = "SoftwareAccess",
    FirmwareAccess = "FirmwareAccess",
    ClevelandAccess = "ClevelandAccess",
}
export interface UserOptionsDto  {
  lastReadNotificationDate: number | null;
  isFirmwareNotificationsDisabled: boolean | null;
  isQualificationNotificationsDisabled: boolean | null;
  isRepairsNotificationsDisabled: boolean | null;
}
export function deserializeUserOptionsDto(json: string): UserOptionsDto {
  const data = JSON.parse(json) as UserOptionsDto;
  initUserOptionsDto(data);
  return data;
}
export function initUserOptionsDto(_data: UserOptionsDto) {
    return _data;
}
export function serializeUserOptionsDto(_data: UserOptionsDto | undefined) {
  if (_data) {
    _data = prepareSerializeUserOptionsDto(_data as UserOptionsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUserOptionsDto(_data: UserOptionsDto): UserOptionsDto {
  const data: Record<string, any> = { ..._data };
  return data as UserOptionsDto;
}
export interface UserFeatureFlagsDto  {
  aiTranslationRepairsEnabled: boolean;
  aiTranslationWarrantyEnabled: boolean;
  useDeepLTranslation: boolean;
  warrantyRequestSummaryLocalEnabled: boolean;
  emailAuthorizationEnabled: boolean;
  clevelandAccessByQualificationEnabled: boolean;
  /** Allow both Approve and View Cost Estimate */
  approveCostEstimateEnabled: boolean;
  /** Allow viewing of cost estimate */
  viewCostEstimateEnabled: boolean;
}
export function deserializeUserFeatureFlagsDto(json: string): UserFeatureFlagsDto {
  const data = JSON.parse(json) as UserFeatureFlagsDto;
  initUserFeatureFlagsDto(data);
  return data;
}
export function initUserFeatureFlagsDto(_data: UserFeatureFlagsDto) {
    return _data;
}
export function serializeUserFeatureFlagsDto(_data: UserFeatureFlagsDto | undefined) {
  if (_data) {
    _data = prepareSerializeUserFeatureFlagsDto(_data as UserFeatureFlagsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUserFeatureFlagsDto(_data: UserFeatureFlagsDto): UserFeatureFlagsDto {
  const data: Record<string, any> = { ..._data };
  return data as UserFeatureFlagsDto;
}
export interface UpdateCurrentUserInfoDto  {
  options?: UserOptionsDto;
}
export function deserializeUpdateCurrentUserInfoDto(json: string): UpdateCurrentUserInfoDto {
  const data = JSON.parse(json) as UpdateCurrentUserInfoDto;
  initUpdateCurrentUserInfoDto(data);
  return data;
}
export function initUpdateCurrentUserInfoDto(_data: UpdateCurrentUserInfoDto) {
  if (_data) {
    _data.options = _data["options"] && initUserOptionsDto(_data["options"]);
  }
  return _data;
}
export function serializeUpdateCurrentUserInfoDto(_data: UpdateCurrentUserInfoDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateCurrentUserInfoDto(_data as UpdateCurrentUserInfoDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateCurrentUserInfoDto(_data: UpdateCurrentUserInfoDto): UpdateCurrentUserInfoDto {
  const data: Record<string, any> = { ..._data };
  data["options"] = _data.options && prepareSerializeUserOptionsDto(_data.options);
  return data as UpdateCurrentUserInfoDto;
}
/** We use [RequiredOrMissing] on all fields to have error 400 if someone tries to pass null or empty values since they are not valid. */
export interface UpdateUserDto  {
  firstName?: string;
  lastName?: string;
  email?: string;
  countryCode?: string;
  isLocked?: boolean;
  claims?: string[];
  options?: UserOptionsDto;
}
export function deserializeUpdateUserDto(json: string): UpdateUserDto {
  const data = JSON.parse(json) as UpdateUserDto;
  initUpdateUserDto(data);
  return data;
}
export function initUpdateUserDto(_data: UpdateUserDto) {
  if (_data) {
    _data.claims = _data["claims"];
    _data.options = _data["options"] && initUserOptionsDto(_data["options"]);
  }
  return _data;
}
export function serializeUpdateUserDto(_data: UpdateUserDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateUserDto(_data as UpdateUserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateUserDto(_data: UpdateUserDto): UpdateUserDto {
  const data: Record<string, any> = { ..._data };
  data["options"] = _data.options && prepareSerializeUserOptionsDto(_data.options);
  return data as UpdateUserDto;
}
export interface ChangePasswordDto  {
  oldPassword: string;
  newPassword: string;
}
export function deserializeChangePasswordDto(json: string): ChangePasswordDto {
  const data = JSON.parse(json) as ChangePasswordDto;
  initChangePasswordDto(data);
  return data;
}
export function initChangePasswordDto(_data: ChangePasswordDto) {
    return _data;
}
export function serializeChangePasswordDto(_data: ChangePasswordDto | undefined) {
  if (_data) {
    _data = prepareSerializeChangePasswordDto(_data as ChangePasswordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeChangePasswordDto(_data: ChangePasswordDto): ChangePasswordDto {
  const data: Record<string, any> = { ..._data };
  return data as ChangePasswordDto;
}
export interface PatchRepairsOrderStatusDto  {
  status: string;
}
export function deserializePatchRepairsOrderStatusDto(json: string): PatchRepairsOrderStatusDto {
  const data = JSON.parse(json) as PatchRepairsOrderStatusDto;
  initPatchRepairsOrderStatusDto(data);
  return data;
}
export function initPatchRepairsOrderStatusDto(_data: PatchRepairsOrderStatusDto) {
    return _data;
}
export function serializePatchRepairsOrderStatusDto(_data: PatchRepairsOrderStatusDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchRepairsOrderStatusDto(_data as PatchRepairsOrderStatusDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchRepairsOrderStatusDto(_data: PatchRepairsOrderStatusDto): PatchRepairsOrderStatusDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchRepairsOrderStatusDto;
}
export interface CreateTestTenantDto  {
  userEmail: string;
  userPassword: string;
}
export function deserializeCreateTestTenantDto(json: string): CreateTestTenantDto {
  const data = JSON.parse(json) as CreateTestTenantDto;
  initCreateTestTenantDto(data);
  return data;
}
export function initCreateTestTenantDto(_data: CreateTestTenantDto) {
    return _data;
}
export function serializeCreateTestTenantDto(_data: CreateTestTenantDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTestTenantDto(_data as CreateTestTenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTestTenantDto(_data: CreateTestTenantDto): CreateTestTenantDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateTestTenantDto;
}
export interface TelehealthBillingResponseDto  {
  countOfRecords: number;
  documents: TelehealthBillingDocument[];
}
export function deserializeTelehealthBillingResponseDto(json: string): TelehealthBillingResponseDto {
  const data = JSON.parse(json) as TelehealthBillingResponseDto;
  initTelehealthBillingResponseDto(data);
  return data;
}
export function initTelehealthBillingResponseDto(_data: TelehealthBillingResponseDto) {
  if (_data) {
    if (Array.isArray(_data["documents"])) {
      _data.documents = _data["documents"].map(item => 
        initTelehealthBillingDocument(item)
      );
    }
  }
  return _data;
}
export function serializeTelehealthBillingResponseDto(_data: TelehealthBillingResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeTelehealthBillingResponseDto(_data as TelehealthBillingResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTelehealthBillingResponseDto(_data: TelehealthBillingResponseDto): TelehealthBillingResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.documents)) {
    data["documents"] = _data.documents.map(item => 
        prepareSerializeTelehealthBillingDocument(item)
    );
  }
  return data as TelehealthBillingResponseDto;
}
export interface TelehealthBillingDocument  {
  invoice: string;
  position: number;
  date: Date | null;
  link: string;
}
export function deserializeTelehealthBillingDocument(json: string): TelehealthBillingDocument {
  const data = JSON.parse(json) as TelehealthBillingDocument;
  initTelehealthBillingDocument(data);
  return data;
}
export function initTelehealthBillingDocument(_data: TelehealthBillingDocument) {
  if (_data) {
    _data.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
  }
  return _data;
}
export function serializeTelehealthBillingDocument(_data: TelehealthBillingDocument | undefined) {
  if (_data) {
    _data = prepareSerializeTelehealthBillingDocument(_data as TelehealthBillingDocument);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTelehealthBillingDocument(_data: TelehealthBillingDocument): TelehealthBillingDocument {
  const data: Record<string, any> = { ..._data };
  data["date"] = _data.date && formatDate(_data.date);
  return data as TelehealthBillingDocument;
}
export interface ServicePresentationResponseDto  {
  countOfRecords: number;
  serviceDocuments: ServiceDocument[];
}
export function deserializeServicePresentationResponseDto(json: string): ServicePresentationResponseDto {
  const data = JSON.parse(json) as ServicePresentationResponseDto;
  initServicePresentationResponseDto(data);
  return data;
}
export function initServicePresentationResponseDto(_data: ServicePresentationResponseDto) {
  if (_data) {
    if (Array.isArray(_data["serviceDocuments"])) {
      _data.serviceDocuments = _data["serviceDocuments"].map(item => 
        initServiceDocument(item)
      );
    }
  }
  return _data;
}
export function serializeServicePresentationResponseDto(_data: ServicePresentationResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeServicePresentationResponseDto(_data as ServicePresentationResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeServicePresentationResponseDto(_data: ServicePresentationResponseDto): ServicePresentationResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.serviceDocuments)) {
    data["serviceDocuments"] = _data.serviceDocuments.map(item => 
        prepareSerializeServiceDocument(item)
    );
  }
  return data as ServicePresentationResponseDto;
}
export interface ServiceDocument  {
  name: string;
  validFrom: Date;
  link: string;
}
export function deserializeServiceDocument(json: string): ServiceDocument {
  const data = JSON.parse(json) as ServiceDocument;
  initServiceDocument(data);
  return data;
}
export function initServiceDocument(_data: ServiceDocument) {
  if (_data) {
    _data.validFrom = _data["validFrom"] ? parseDateOnly(_data["validFrom"].toString()) : <any>null;
  }
  return _data;
}
export function serializeServiceDocument(_data: ServiceDocument | undefined) {
  if (_data) {
    _data = prepareSerializeServiceDocument(_data as ServiceDocument);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeServiceDocument(_data: ServiceDocument): ServiceDocument {
  const data: Record<string, any> = { ..._data };
  data["validFrom"] = _data.validFrom && formatDate(_data.validFrom);
  return data as ServiceDocument;
}
export interface ResponseServiceAndRepairDto  {
  countOfRecordWithFilters: number;
  serviceAndRepairDocuments: ServiceAndRepairDocument[];
}
export function deserializeResponseServiceAndRepairDto(json: string): ResponseServiceAndRepairDto {
  const data = JSON.parse(json) as ResponseServiceAndRepairDto;
  initResponseServiceAndRepairDto(data);
  return data;
}
export function initResponseServiceAndRepairDto(_data: ResponseServiceAndRepairDto) {
  if (_data) {
    if (Array.isArray(_data["serviceAndRepairDocuments"])) {
      _data.serviceAndRepairDocuments = _data["serviceAndRepairDocuments"].map(item => 
        initServiceAndRepairDocument(item)
      );
    }
  }
  return _data;
}
export function serializeResponseServiceAndRepairDto(_data: ResponseServiceAndRepairDto | undefined) {
  if (_data) {
    _data = prepareSerializeResponseServiceAndRepairDto(_data as ResponseServiceAndRepairDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeResponseServiceAndRepairDto(_data: ResponseServiceAndRepairDto): ResponseServiceAndRepairDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.serviceAndRepairDocuments)) {
    data["serviceAndRepairDocuments"] = _data.serviceAndRepairDocuments.map(item => 
        prepareSerializeServiceAndRepairDocument(item)
    );
  }
  return data as ResponseServiceAndRepairDto;
}
export interface ServiceAndRepairDocument  {
  name: string;
  groupId: number;
  groupName: string;
  documentDownloadLinks: DocumentDownloadLink[];
}
export function deserializeServiceAndRepairDocument(json: string): ServiceAndRepairDocument {
  const data = JSON.parse(json) as ServiceAndRepairDocument;
  initServiceAndRepairDocument(data);
  return data;
}
export function initServiceAndRepairDocument(_data: ServiceAndRepairDocument) {
  if (_data) {
    if (Array.isArray(_data["documentDownloadLinks"])) {
      _data.documentDownloadLinks = _data["documentDownloadLinks"].map(item => 
        initDocumentDownloadLink(item)
      );
    }
  }
  return _data;
}
export function serializeServiceAndRepairDocument(_data: ServiceAndRepairDocument | undefined) {
  if (_data) {
    _data = prepareSerializeServiceAndRepairDocument(_data as ServiceAndRepairDocument);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeServiceAndRepairDocument(_data: ServiceAndRepairDocument): ServiceAndRepairDocument {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.documentDownloadLinks)) {
    data["documentDownloadLinks"] = _data.documentDownloadLinks.map(item => 
        prepareSerializeDocumentDownloadLink(item)
    );
  }
  return data as ServiceAndRepairDocument;
}
export interface DocumentDownloadLink  {
  language: string;
  link: string;
}
export function deserializeDocumentDownloadLink(json: string): DocumentDownloadLink {
  const data = JSON.parse(json) as DocumentDownloadLink;
  initDocumentDownloadLink(data);
  return data;
}
export function initDocumentDownloadLink(_data: DocumentDownloadLink) {
    return _data;
}
export function serializeDocumentDownloadLink(_data: DocumentDownloadLink | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentDownloadLink(_data as DocumentDownloadLink);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentDownloadLink(_data: DocumentDownloadLink): DocumentDownloadLink {
  const data: Record<string, any> = { ..._data };
  return data as DocumentDownloadLink;
}
export interface SerialNumberResponseDto  {
  countOfRecords: number;
  records: SerialNumberRecord[];
}
export function deserializeSerialNumberResponseDto(json: string): SerialNumberResponseDto {
  const data = JSON.parse(json) as SerialNumberResponseDto;
  initSerialNumberResponseDto(data);
  return data;
}
export function initSerialNumberResponseDto(_data: SerialNumberResponseDto) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initSerialNumberRecord(item)
      );
    }
  }
  return _data;
}
export function serializeSerialNumberResponseDto(_data: SerialNumberResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeSerialNumberResponseDto(_data as SerialNumberResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSerialNumberResponseDto(_data: SerialNumberResponseDto): SerialNumberResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeSerialNumberRecord(item)
    );
  }
  return data as SerialNumberResponseDto;
}
export interface SerialNumberRecord  {
  number: string;
  type: string;
  validFrom: Date;
  link: string;
}
export function deserializeSerialNumberRecord(json: string): SerialNumberRecord {
  const data = JSON.parse(json) as SerialNumberRecord;
  initSerialNumberRecord(data);
  return data;
}
export function initSerialNumberRecord(_data: SerialNumberRecord) {
  if (_data) {
    _data.validFrom = _data["validFrom"] ? parseDateOnly(_data["validFrom"].toString()) : <any>null;
  }
  return _data;
}
export function serializeSerialNumberRecord(_data: SerialNumberRecord | undefined) {
  if (_data) {
    _data = prepareSerializeSerialNumberRecord(_data as SerialNumberRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSerialNumberRecord(_data: SerialNumberRecord): SerialNumberRecord {
  const data: Record<string, any> = { ..._data };
  data["validFrom"] = _data.validFrom && formatDate(_data.validFrom);
  return data as SerialNumberRecord;
}
export interface CreateUserResponseDto  {
  id: string;
}
export function deserializeCreateUserResponseDto(json: string): CreateUserResponseDto {
  const data = JSON.parse(json) as CreateUserResponseDto;
  initCreateUserResponseDto(data);
  return data;
}
export function initCreateUserResponseDto(_data: CreateUserResponseDto) {
    return _data;
}
export function serializeCreateUserResponseDto(_data: CreateUserResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateUserResponseDto(_data as CreateUserResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateUserResponseDto(_data: CreateUserResponseDto): CreateUserResponseDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateUserResponseDto;
}
export interface CreateUserDto  {
  realName: string;
  countryCode: string;
  email: string;
  roles: string[];
}
export function deserializeCreateUserDto(json: string): CreateUserDto {
  const data = JSON.parse(json) as CreateUserDto;
  initCreateUserDto(data);
  return data;
}
export function initCreateUserDto(_data: CreateUserDto) {
  if (_data) {
    _data.roles = _data["roles"];
  }
  return _data;
}
export function serializeCreateUserDto(_data: CreateUserDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateUserDto(_data as CreateUserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateUserDto(_data: CreateUserDto): CreateUserDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateUserDto;
}
export interface PagedResultOfSearchResultDto  {
  data: SearchResultDto[];
  totalCount: number;
}
export function deserializePagedResultOfSearchResultDto(json: string): PagedResultOfSearchResultDto {
  const data = JSON.parse(json) as PagedResultOfSearchResultDto;
  initPagedResultOfSearchResultDto(data);
  return data;
}
export function initPagedResultOfSearchResultDto(_data: PagedResultOfSearchResultDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initSearchResultDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfSearchResultDto(_data: PagedResultOfSearchResultDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfSearchResultDto(_data as PagedResultOfSearchResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfSearchResultDto(_data: PagedResultOfSearchResultDto): PagedResultOfSearchResultDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeSearchResultDto(item)
    );
  }
  return data as PagedResultOfSearchResultDto;
}
export interface SearchResultDto  {
  pageName: string;
  /** e.x Filename or CMS page content snippet */
  foundSearchValue: string;
  fileLink: string;
  cmsPageUrl: string;
  matchedFields: { [key: string]: string; };
  matchedInnerFields: { [key: string]: string; };
}
export function deserializeSearchResultDto(json: string): SearchResultDto {
  const data = JSON.parse(json) as SearchResultDto;
  initSearchResultDto(data);
  return data;
}
export function initSearchResultDto(_data: SearchResultDto) {
    return _data;
}
export function serializeSearchResultDto(_data: SearchResultDto | undefined) {
  if (_data) {
    _data = prepareSerializeSearchResultDto(_data as SearchResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSearchResultDto(_data: SearchResultDto): SearchResultDto {
  const data: Record<string, any> = { ..._data };
  return data as SearchResultDto;
}
export interface PagedResultOfSearchResultGroupedDto  {
  data: SearchResultGroupedDto[];
  totalCount: number;
}
export function deserializePagedResultOfSearchResultGroupedDto(json: string): PagedResultOfSearchResultGroupedDto {
  const data = JSON.parse(json) as PagedResultOfSearchResultGroupedDto;
  initPagedResultOfSearchResultGroupedDto(data);
  return data;
}
export function initPagedResultOfSearchResultGroupedDto(_data: PagedResultOfSearchResultGroupedDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initSearchResultGroupedDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfSearchResultGroupedDto(_data: PagedResultOfSearchResultGroupedDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfSearchResultGroupedDto(_data as PagedResultOfSearchResultGroupedDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfSearchResultGroupedDto(_data: PagedResultOfSearchResultGroupedDto): PagedResultOfSearchResultGroupedDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeSearchResultGroupedDto(item)
    );
  }
  return data as PagedResultOfSearchResultGroupedDto;
}
export interface SearchResultGroupedDto  {
  pageName: string;
  searchResults: SearchResultDto[];
}
export function deserializeSearchResultGroupedDto(json: string): SearchResultGroupedDto {
  const data = JSON.parse(json) as SearchResultGroupedDto;
  initSearchResultGroupedDto(data);
  return data;
}
export function initSearchResultGroupedDto(_data: SearchResultGroupedDto) {
  if (_data) {
    if (Array.isArray(_data["searchResults"])) {
      _data.searchResults = _data["searchResults"].map(item => 
        initSearchResultDto(item)
      );
    }
  }
  return _data;
}
export function serializeSearchResultGroupedDto(_data: SearchResultGroupedDto | undefined) {
  if (_data) {
    _data = prepareSerializeSearchResultGroupedDto(_data as SearchResultGroupedDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSearchResultGroupedDto(_data: SearchResultGroupedDto): SearchResultGroupedDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.searchResults)) {
    data["searchResults"] = _data.searchResults.map(item => 
        prepareSerializeSearchResultDto(item)
    );
  }
  return data as SearchResultGroupedDto;
}
export enum SearchCategory {
    WarrantyRequestSummary = "WarrantyRequestSummary",
    OrderList = "OrderList",
    OutstandingReceivables = "OutstandingReceivables",
    AbasDocuments = "AbasDocuments",
    Repairs = "Repairs",
    CmsPages = "CmsPages",
    Qualifications = "Qualifications",
}
export interface RepairsResponseDto  {
  countOfRecords: number;
  records: RepairsRecord[];
}
export function deserializeRepairsResponseDto(json: string): RepairsResponseDto {
  const data = JSON.parse(json) as RepairsResponseDto;
  initRepairsResponseDto(data);
  return data;
}
export function initRepairsResponseDto(_data: RepairsResponseDto) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initRepairsRecord(item)
      );
    }
  }
  return _data;
}
export function serializeRepairsResponseDto(_data: RepairsResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeRepairsResponseDto(_data as RepairsResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairsResponseDto(_data: RepairsResponseDto): RepairsResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeRepairsRecord(item)
    );
  }
  return data as RepairsResponseDto;
}
export interface RepairsRecord  {
  order: string;
  from: Date;
  yourOrder: string;
  yourReference: string;
  status: string;
  position: string;
  article: string;
  sn: string;
  name: string;
  count: number;
}
export function deserializeRepairsRecord(json: string): RepairsRecord {
  const data = JSON.parse(json) as RepairsRecord;
  initRepairsRecord(data);
  return data;
}
export function initRepairsRecord(_data: RepairsRecord) {
  if (_data) {
    _data.from = _data["from"] ? parseDateOnly(_data["from"].toString()) : <any>null;
  }
  return _data;
}
export function serializeRepairsRecord(_data: RepairsRecord | undefined) {
  if (_data) {
    _data = prepareSerializeRepairsRecord(_data as RepairsRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairsRecord(_data: RepairsRecord): RepairsRecord {
  const data: Record<string, any> = { ..._data };
  data["from"] = _data.from && formatDate(_data.from);
  return data as RepairsRecord;
}
export interface RepairsDetailsDto  {
  records: RepairsRecord[];
  statusHistory: RepairsOrderStatusDto[];
  deliveryInfo: DeliveryInfoDto;
}
export function deserializeRepairsDetailsDto(json: string): RepairsDetailsDto {
  const data = JSON.parse(json) as RepairsDetailsDto;
  initRepairsDetailsDto(data);
  return data;
}
export function initRepairsDetailsDto(_data: RepairsDetailsDto) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initRepairsRecord(item)
      );
    }
    if (Array.isArray(_data["statusHistory"])) {
      _data.statusHistory = _data["statusHistory"].map(item => 
        initRepairsOrderStatusDto(item)
      );
    }
    _data.deliveryInfo = _data["deliveryInfo"] && initDeliveryInfoDto(_data["deliveryInfo"]);
  }
  return _data;
}
export function serializeRepairsDetailsDto(_data: RepairsDetailsDto | undefined) {
  if (_data) {
    _data = prepareSerializeRepairsDetailsDto(_data as RepairsDetailsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairsDetailsDto(_data: RepairsDetailsDto): RepairsDetailsDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeRepairsRecord(item)
    );
  }
  if (Array.isArray(_data.statusHistory)) {
    data["statusHistory"] = _data.statusHistory.map(item => 
        prepareSerializeRepairsOrderStatusDto(item)
    );
  }
  data["deliveryInfo"] = _data.deliveryInfo && prepareSerializeDeliveryInfoDto(_data.deliveryInfo);
  return data as RepairsDetailsDto;
}
export interface RepairsOrderStatusDto  {
  id: number;
  status: string;
  createdAt: Date;
}
export function deserializeRepairsOrderStatusDto(json: string): RepairsOrderStatusDto {
  const data = JSON.parse(json) as RepairsOrderStatusDto;
  initRepairsOrderStatusDto(data);
  return data;
}
export function initRepairsOrderStatusDto(_data: RepairsOrderStatusDto) {
  if (_data) {
    _data.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializeRepairsOrderStatusDto(_data: RepairsOrderStatusDto | undefined) {
  if (_data) {
    _data = prepareSerializeRepairsOrderStatusDto(_data as RepairsOrderStatusDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairsOrderStatusDto(_data: RepairsOrderStatusDto): RepairsOrderStatusDto {
  const data: Record<string, any> = { ..._data };
  data["createdAt"] = _data.createdAt && _data.createdAt.toISOString();
  return data as RepairsOrderStatusDto;
}
export interface DeliveryInfoDto  {
  company: string;
  departure: string;
  contact: string;
  address: string;
  street: string;
  city: string;
  country: string;
}
export function deserializeDeliveryInfoDto(json: string): DeliveryInfoDto {
  const data = JSON.parse(json) as DeliveryInfoDto;
  initDeliveryInfoDto(data);
  return data;
}
export function initDeliveryInfoDto(_data: DeliveryInfoDto) {
    return _data;
}
export function serializeDeliveryInfoDto(_data: DeliveryInfoDto | undefined) {
  if (_data) {
    _data = prepareSerializeDeliveryInfoDto(_data as DeliveryInfoDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDeliveryInfoDto(_data: DeliveryInfoDto): DeliveryInfoDto {
  const data: Record<string, any> = { ..._data };
  return data as DeliveryInfoDto;
}
export interface InvoiceAddressDto  {
  contactId: string;
  contact: string;
  street: string;
  countryCode: string;
  postCode: string;
  city: string;
  phoneNumber: string;
}
export function deserializeInvoiceAddressDto(json: string): InvoiceAddressDto {
  const data = JSON.parse(json) as InvoiceAddressDto;
  initInvoiceAddressDto(data);
  return data;
}
export function initInvoiceAddressDto(_data: InvoiceAddressDto) {
    return _data;
}
export function serializeInvoiceAddressDto(_data: InvoiceAddressDto | undefined) {
  if (_data) {
    _data = prepareSerializeInvoiceAddressDto(_data as InvoiceAddressDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeInvoiceAddressDto(_data: InvoiceAddressDto): InvoiceAddressDto {
  const data: Record<string, any> = { ..._data };
  return data as InvoiceAddressDto;
}
export interface CreateRepairOrderDto  {
  /** (seriennummer) */
  serialNumber: string | null;
  /** (serviceprodukt). */
  serviceProduct: string | null;
  /** Device article (is used for showing to user, not for creating repair order). */
  article: string | null;
  /** Device name (is used for showing to user, not for creating repair order). */
  deviceName: string | null;
  /** (artohnesn).NOTE: spike / may be deleted in future */
  withoutSerialNumber: boolean | null;
  /** If there is no serial number, a description of the device is required (wasbinich) */
  deviceDescription: string | null;
  /** List of reasons for return (rueckgabegrund) */
  reasonsForReturn: ReasonForReturn[];
  /** Additional error description (fehlertext) */
  additionalErrorDescription: string | null;
  /** List that contains selected device errors as key/text options. */
  selectedErrors: RepairErrorOptionDto[];
  salesReceiptFileId: string | null;
  replacementAlreadyReceived: boolean | null;
  repairLimitEuro: number | null;
  workRequiredImmediately: boolean | null;
  ticketId: string | null;
}
export function deserializeCreateRepairOrderDto(json: string): CreateRepairOrderDto {
  const data = JSON.parse(json) as CreateRepairOrderDto;
  initCreateRepairOrderDto(data);
  return data;
}
export function initCreateRepairOrderDto(_data: CreateRepairOrderDto) {
  if (_data) {
    _data.reasonsForReturn = _data["reasonsForReturn"];
    if (Array.isArray(_data["selectedErrors"])) {
      _data.selectedErrors = _data["selectedErrors"].map(item => 
        initRepairErrorOptionDto(item)
      );
    }
  }
  return _data;
}
export function serializeCreateRepairOrderDto(_data: CreateRepairOrderDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateRepairOrderDto(_data as CreateRepairOrderDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateRepairOrderDto(_data: CreateRepairOrderDto): CreateRepairOrderDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.selectedErrors)) {
    data["selectedErrors"] = _data.selectedErrors.map(item => 
        prepareSerializeRepairErrorOptionDto(item)
    );
  }
  return data as CreateRepairOrderDto;
}
export enum ReasonForReturn {
    Maintenance = "Maintenance",
    Repair = "Repair",
    Warranty = "Warranty",
    ReturnForCredit = "ReturnForCredit",
    ReturnOfExchangeArticle = "ReturnOfExchangeArticle",
    HygienicReprocessingOrdered = "HygienicReprocessingOrdered",
    CustomerRequestsCompletion = "CustomerRequestsCompletion",
    CaseIsIncident = "CaseIsIncident",
    CustomerWantsCostEstimate = "CustomerWantsCostEstimate",
}
export interface RepairErrorOptionDto  {
  key: string;
  text: string;
}
export function deserializeRepairErrorOptionDto(json: string): RepairErrorOptionDto {
  const data = JSON.parse(json) as RepairErrorOptionDto;
  initRepairErrorOptionDto(data);
  return data;
}
export function initRepairErrorOptionDto(_data: RepairErrorOptionDto) {
    return _data;
}
export function serializeRepairErrorOptionDto(_data: RepairErrorOptionDto | undefined) {
  if (_data) {
    _data = prepareSerializeRepairErrorOptionDto(_data as RepairErrorOptionDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairErrorOptionDto(_data: RepairErrorOptionDto): RepairErrorOptionDto {
  const data: Record<string, any> = { ..._data };
  return data as RepairErrorOptionDto;
}
export interface CreateInternalRepairOrderDto  {
  contactId?: string | null;
  contact?: string | null;
  street?: string | null;
  countryCode?: string | null;
  postCode?: string | null;
  city?: string | null;
  phoneNumber?: string | null;
}
export function deserializeCreateInternalRepairOrderDto(json: string): CreateInternalRepairOrderDto {
  const data = JSON.parse(json) as CreateInternalRepairOrderDto;
  initCreateInternalRepairOrderDto(data);
  return data;
}
export function initCreateInternalRepairOrderDto(_data: CreateInternalRepairOrderDto) {
    return _data;
}
export function serializeCreateInternalRepairOrderDto(_data: CreateInternalRepairOrderDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateInternalRepairOrderDto(_data as CreateInternalRepairOrderDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateInternalRepairOrderDto(_data: CreateInternalRepairOrderDto): CreateInternalRepairOrderDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateInternalRepairOrderDto;
}
export interface RepairOrderDraftListDto  {
  drafts: RepairOrderDraftListItemDto[];
  internalIncomingNumber: string;
}
export function deserializeRepairOrderDraftListDto(json: string): RepairOrderDraftListDto {
  const data = JSON.parse(json) as RepairOrderDraftListDto;
  initRepairOrderDraftListDto(data);
  return data;
}
export function initRepairOrderDraftListDto(_data: RepairOrderDraftListDto) {
  if (_data) {
    if (Array.isArray(_data["drafts"])) {
      _data.drafts = _data["drafts"].map(item => 
        initRepairOrderDraftListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializeRepairOrderDraftListDto(_data: RepairOrderDraftListDto | undefined) {
  if (_data) {
    _data = prepareSerializeRepairOrderDraftListDto(_data as RepairOrderDraftListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairOrderDraftListDto(_data: RepairOrderDraftListDto): RepairOrderDraftListDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.drafts)) {
    data["drafts"] = _data.drafts.map(item => 
        prepareSerializeRepairOrderDraftListItemDto(item)
    );
  }
  return data as RepairOrderDraftListDto;
}
export interface RepairOrderDraftListItemDto  {
  id: number;
  serialNumber: string | null;
  serviceProduct: string | null;
  article: string | null;
  deviceName: string | null;
  withoutSerialNumber: boolean | null;
  deviceDescription: string | null;
  reasonsForReturn: ReasonForReturn[];
  additionalErrorDescription: string | null;
  selectedErrors: RepairErrorOptionDto[];
  salesReceiptFileId: string | null;
  salesReceiptFileName: string | null;
  replacementAlreadyReceived: boolean | null;
  repairLimitEuro: number | null;
  workRequiredImmediately: boolean | null;
  ticketId: string | null;
  incomingNumber: string | null;
}
export function deserializeRepairOrderDraftListItemDto(json: string): RepairOrderDraftListItemDto {
  const data = JSON.parse(json) as RepairOrderDraftListItemDto;
  initRepairOrderDraftListItemDto(data);
  return data;
}
export function initRepairOrderDraftListItemDto(_data: RepairOrderDraftListItemDto) {
  if (_data) {
    _data.reasonsForReturn = _data["reasonsForReturn"];
    if (Array.isArray(_data["selectedErrors"])) {
      _data.selectedErrors = _data["selectedErrors"].map(item => 
        initRepairErrorOptionDto(item)
      );
    }
  }
  return _data;
}
export function serializeRepairOrderDraftListItemDto(_data: RepairOrderDraftListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeRepairOrderDraftListItemDto(_data as RepairOrderDraftListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairOrderDraftListItemDto(_data: RepairOrderDraftListItemDto): RepairOrderDraftListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.selectedErrors)) {
    data["selectedErrors"] = _data.selectedErrors.map(item => 
        prepareSerializeRepairErrorOptionDto(item)
    );
  }
  return data as RepairOrderDraftListItemDto;
}
export interface RepairDeviceDto  {
  /** Selected serial number (serviceprodukt text field) */
  serialNumber: string;
  /** Selected service product ID (serviceprodukt value field) */
  serviceProductId: string;
  /** Device article (yghart) */
  article: string;
  /** Device name (artname) */
  deviceName: string;
  availableErrors: { [key: string]: string; } | null;
  foundDevices: FoundRepairsDeviceDto[] | null;
  services: ReasonForReturn[] | null;
}
export function deserializeRepairDeviceDto(json: string): RepairDeviceDto {
  const data = JSON.parse(json) as RepairDeviceDto;
  initRepairDeviceDto(data);
  return data;
}
export function initRepairDeviceDto(_data: RepairDeviceDto) {
  if (_data) {
    if (Array.isArray(_data["foundDevices"])) {
      _data.foundDevices = _data["foundDevices"].map(item => 
        initFoundRepairsDeviceDto(item)
      );
    }
    _data.services = _data["services"];
  }
  return _data;
}
export function serializeRepairDeviceDto(_data: RepairDeviceDto | undefined) {
  if (_data) {
    _data = prepareSerializeRepairDeviceDto(_data as RepairDeviceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRepairDeviceDto(_data: RepairDeviceDto): RepairDeviceDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.foundDevices)) {
    data["foundDevices"] = _data.foundDevices.map(item => 
        prepareSerializeFoundRepairsDeviceDto(item)
    );
  }
  return data as RepairDeviceDto;
}
export interface FoundRepairsDeviceDto  {
  serviceProductId: string;
  serialNumber: string;
  deviceName: string;
  article: string;
  customerNumber: string;
}
export function deserializeFoundRepairsDeviceDto(json: string): FoundRepairsDeviceDto {
  const data = JSON.parse(json) as FoundRepairsDeviceDto;
  initFoundRepairsDeviceDto(data);
  return data;
}
export function initFoundRepairsDeviceDto(_data: FoundRepairsDeviceDto) {
    return _data;
}
export function serializeFoundRepairsDeviceDto(_data: FoundRepairsDeviceDto | undefined) {
  if (_data) {
    _data = prepareSerializeFoundRepairsDeviceDto(_data as FoundRepairsDeviceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFoundRepairsDeviceDto(_data: FoundRepairsDeviceDto): FoundRepairsDeviceDto {
  const data: Record<string, any> = { ..._data };
  return data as FoundRepairsDeviceDto;
}
export interface PatchRepairOrderDraftDto  {
  serialNumber?: string | null;
  serviceProduct?: string | null;
  article?: string | null;
  deviceName?: string | null;
  withoutSerialNumber?: boolean | null;
  deviceDescription?: string | null;
  reasonsForReturn?: ReasonForReturn[] | null;
  additionalErrorDescription?: string | null;
  selectedErrors?: RepairErrorOptionDto[] | null;
  salesReceiptFileId?: string | null;
  replacementAlreadyReceived?: boolean | null;
  repairLimitEuro?: number | null;
  workRequiredImmediately?: boolean | null;
  ticketId?: string | null;
  submittedAt?: Date | null;
  incomingNumber?: string | null;
}
export function deserializePatchRepairOrderDraftDto(json: string): PatchRepairOrderDraftDto {
  const data = JSON.parse(json) as PatchRepairOrderDraftDto;
  initPatchRepairOrderDraftDto(data);
  return data;
}
export function initPatchRepairOrderDraftDto(_data: PatchRepairOrderDraftDto) {
  if (_data) {
    _data.reasonsForReturn = _data["reasonsForReturn"];
    if (Array.isArray(_data["selectedErrors"])) {
      _data.selectedErrors = _data["selectedErrors"].map(item => 
        initRepairErrorOptionDto(item)
      );
    }
    _data.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializePatchRepairOrderDraftDto(_data: PatchRepairOrderDraftDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchRepairOrderDraftDto(_data as PatchRepairOrderDraftDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchRepairOrderDraftDto(_data: PatchRepairOrderDraftDto): PatchRepairOrderDraftDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.selectedErrors)) {
    data["selectedErrors"] = _data.selectedErrors.map(item => 
        prepareSerializeRepairErrorOptionDto(item)
    );
  }
  data["submittedAt"] = _data.submittedAt && _data.submittedAt.toISOString();
  return data as PatchRepairOrderDraftDto;
}
export interface SubmitRepairOrderResponseDto  {
  isSuccessful: boolean;
  failedDrafts: FailedRepairOrderDraftDto[];
}
export function deserializeSubmitRepairOrderResponseDto(json: string): SubmitRepairOrderResponseDto {
  const data = JSON.parse(json) as SubmitRepairOrderResponseDto;
  initSubmitRepairOrderResponseDto(data);
  return data;
}
export function initSubmitRepairOrderResponseDto(_data: SubmitRepairOrderResponseDto) {
  if (_data) {
    if (Array.isArray(_data["failedDrafts"])) {
      _data.failedDrafts = _data["failedDrafts"].map(item => 
        initFailedRepairOrderDraftDto(item)
      );
    }
  }
  return _data;
}
export function serializeSubmitRepairOrderResponseDto(_data: SubmitRepairOrderResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeSubmitRepairOrderResponseDto(_data as SubmitRepairOrderResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSubmitRepairOrderResponseDto(_data: SubmitRepairOrderResponseDto): SubmitRepairOrderResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.failedDrafts)) {
    data["failedDrafts"] = _data.failedDrafts.map(item => 
        prepareSerializeFailedRepairOrderDraftDto(item)
    );
  }
  return data as SubmitRepairOrderResponseDto;
}
export interface FailedRepairOrderDraftDto  {
  draftId: number;
  error: string;
}
export function deserializeFailedRepairOrderDraftDto(json: string): FailedRepairOrderDraftDto {
  const data = JSON.parse(json) as FailedRepairOrderDraftDto;
  initFailedRepairOrderDraftDto(data);
  return data;
}
export function initFailedRepairOrderDraftDto(_data: FailedRepairOrderDraftDto) {
    return _data;
}
export function serializeFailedRepairOrderDraftDto(_data: FailedRepairOrderDraftDto | undefined) {
  if (_data) {
    _data = prepareSerializeFailedRepairOrderDraftDto(_data as FailedRepairOrderDraftDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFailedRepairOrderDraftDto(_data: FailedRepairOrderDraftDto): FailedRepairOrderDraftDto {
  const data: Record<string, any> = { ..._data };
  return data as FailedRepairOrderDraftDto;
}
export interface SalesViewDto  {
  netTotalSum: number;
  grossTotalSum: number;
  items: SalesViewItemDto[];
}
export function deserializeSalesViewDto(json: string): SalesViewDto {
  const data = JSON.parse(json) as SalesViewDto;
  initSalesViewDto(data);
  return data;
}
export function initSalesViewDto(_data: SalesViewDto) {
  if (_data) {
    if (Array.isArray(_data["items"])) {
      _data.items = _data["items"].map(item => 
        initSalesViewItemDto(item)
      );
    }
  }
  return _data;
}
export function serializeSalesViewDto(_data: SalesViewDto | undefined) {
  if (_data) {
    _data = prepareSerializeSalesViewDto(_data as SalesViewDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSalesViewDto(_data: SalesViewDto): SalesViewDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.items)) {
    data["items"] = _data.items.map(item => 
        prepareSerializeSalesViewItemDto(item)
    );
  }
  return data as SalesViewDto;
}
export interface SalesViewItemDto  {
  itemPos: string;
  typeOfApplication: string;
  article: string;
  productDescription: string;
  unitOfSaleCount: number | null;
  unitOfSaleType: string;
  initialPrice: number | null;
  discountInPercent: number | null;
  totalPrice: number | null;
  confirmedDeliveryDate: Date | null;
  contractDate: Date | null;
  customerDesiredDate: Date | null;
}
export function deserializeSalesViewItemDto(json: string): SalesViewItemDto {
  const data = JSON.parse(json) as SalesViewItemDto;
  initSalesViewItemDto(data);
  return data;
}
export function initSalesViewItemDto(_data: SalesViewItemDto) {
  if (_data) {
    _data.confirmedDeliveryDate = _data["confirmedDeliveryDate"] ? parseDateOnly(_data["confirmedDeliveryDate"].toString()) : <any>null;
    _data.contractDate = _data["contractDate"] ? parseDateOnly(_data["contractDate"].toString()) : <any>null;
    _data.customerDesiredDate = _data["customerDesiredDate"] ? parseDateOnly(_data["customerDesiredDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeSalesViewItemDto(_data: SalesViewItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeSalesViewItemDto(_data as SalesViewItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSalesViewItemDto(_data: SalesViewItemDto): SalesViewItemDto {
  const data: Record<string, any> = { ..._data };
  data["confirmedDeliveryDate"] = _data.confirmedDeliveryDate && formatDate(_data.confirmedDeliveryDate);
  data["contractDate"] = _data.contractDate && formatDate(_data.contractDate);
  data["customerDesiredDate"] = _data.customerDesiredDate && formatDate(_data.customerDesiredDate);
  return data as SalesViewItemDto;
}
export interface SalesPrintDto  {
  href: string;
  fileName: string;
  mimeType: string;
  sizeInBytes: number;
}
export function deserializeSalesPrintDto(json: string): SalesPrintDto {
  const data = JSON.parse(json) as SalesPrintDto;
  initSalesPrintDto(data);
  return data;
}
export function initSalesPrintDto(_data: SalesPrintDto) {
    return _data;
}
export function serializeSalesPrintDto(_data: SalesPrintDto | undefined) {
  if (_data) {
    _data = prepareSerializeSalesPrintDto(_data as SalesPrintDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSalesPrintDto(_data: SalesPrintDto): SalesPrintDto {
  const data: Record<string, any> = { ..._data };
  return data as SalesPrintDto;
}
export interface PagedResultOfQualificationResponseDto  {
  data: QualificationResponseDto[];
  totalCount: number;
}
export function deserializePagedResultOfQualificationResponseDto(json: string): PagedResultOfQualificationResponseDto {
  const data = JSON.parse(json) as PagedResultOfQualificationResponseDto;
  initPagedResultOfQualificationResponseDto(data);
  return data;
}
export function initPagedResultOfQualificationResponseDto(_data: PagedResultOfQualificationResponseDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initQualificationResponseDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfQualificationResponseDto(_data: PagedResultOfQualificationResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfQualificationResponseDto(_data as PagedResultOfQualificationResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfQualificationResponseDto(_data: PagedResultOfQualificationResponseDto): PagedResultOfQualificationResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeQualificationResponseDto(item)
    );
  }
  return data as PagedResultOfQualificationResponseDto;
}
export interface QualificationResponseDto  {
  participant: string;
  description: string;
  trainingFrom: Date | null;
  trainingTo: Date | null;
  validTo: Date | null;
}
export function deserializeQualificationResponseDto(json: string): QualificationResponseDto {
  const data = JSON.parse(json) as QualificationResponseDto;
  initQualificationResponseDto(data);
  return data;
}
export function initQualificationResponseDto(_data: QualificationResponseDto) {
  if (_data) {
    _data.trainingFrom = _data["trainingFrom"] ? parseDateOnly(_data["trainingFrom"].toString()) : <any>null;
    _data.trainingTo = _data["trainingTo"] ? parseDateOnly(_data["trainingTo"].toString()) : <any>null;
    _data.validTo = _data["validTo"] ? parseDateOnly(_data["validTo"].toString()) : <any>null;
  }
  return _data;
}
export function serializeQualificationResponseDto(_data: QualificationResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeQualificationResponseDto(_data as QualificationResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeQualificationResponseDto(_data: QualificationResponseDto): QualificationResponseDto {
  const data: Record<string, any> = { ..._data };
  data["trainingFrom"] = _data.trainingFrom && formatDate(_data.trainingFrom);
  data["trainingTo"] = _data.trainingTo && formatDate(_data.trainingTo);
  data["validTo"] = _data.validTo && formatDate(_data.validTo);
  return data as QualificationResponseDto;
}
/** Represents startup options for HangFire job. */
export interface HangFireJobSettings  {
  /** Should be a cron compatible expression that is passed to hangfire scheduler. */
  cronExpression: string | null;
  /** Allows to disable the job (if set to false).
If the value is `true` or `null` the job is enabled. */
  enabled: boolean | null;
}
export function deserializeHangFireJobSettings(json: string): HangFireJobSettings {
  const data = JSON.parse(json) as HangFireJobSettings;
  initHangFireJobSettings(data);
  return data;
}
export function initHangFireJobSettings(_data: HangFireJobSettings) {
    return _data;
}
export function serializeHangFireJobSettings(_data: HangFireJobSettings | undefined) {
  if (_data) {
    _data = prepareSerializeHangFireJobSettings(_data as HangFireJobSettings);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHangFireJobSettings(_data: HangFireJobSettings): HangFireJobSettings {
  const data: Record<string, any> = { ..._data };
  return data as HangFireJobSettings;
}
export interface QualificationNotificatorJobSettings extends HangFireJobSettings  {
  dryRun: boolean;
  createNotificationsForQualifications: boolean;
}
export function deserializeQualificationNotificatorJobSettings(json: string): QualificationNotificatorJobSettings {
  const data = JSON.parse(json) as QualificationNotificatorJobSettings;
  initQualificationNotificatorJobSettings(data);
  return data;
}
export function initQualificationNotificatorJobSettings(_data: QualificationNotificatorJobSettings) {
  initHangFireJobSettings(_data);
    return _data;
}
export function serializeQualificationNotificatorJobSettings(_data: QualificationNotificatorJobSettings | undefined) {
  if (_data) {
    _data = prepareSerializeQualificationNotificatorJobSettings(_data as QualificationNotificatorJobSettings);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeQualificationNotificatorJobSettings(_data: QualificationNotificatorJobSettings): QualificationNotificatorJobSettings {
  const data = prepareSerializeHangFireJobSettings(_data as QualificationNotificatorJobSettings) as Record<string, any>;
  return data as QualificationNotificatorJobSettings;
}
export interface ProfessionalInfoResponseDto  {
  countOfRecords: number;
  professionalInfoDocuments: ProfessionalInfoDocument[];
}
export function deserializeProfessionalInfoResponseDto(json: string): ProfessionalInfoResponseDto {
  const data = JSON.parse(json) as ProfessionalInfoResponseDto;
  initProfessionalInfoResponseDto(data);
  return data;
}
export function initProfessionalInfoResponseDto(_data: ProfessionalInfoResponseDto) {
  if (_data) {
    if (Array.isArray(_data["professionalInfoDocuments"])) {
      _data.professionalInfoDocuments = _data["professionalInfoDocuments"].map(item => 
        initProfessionalInfoDocument(item)
      );
    }
  }
  return _data;
}
export function serializeProfessionalInfoResponseDto(_data: ProfessionalInfoResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeProfessionalInfoResponseDto(_data as ProfessionalInfoResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProfessionalInfoResponseDto(_data: ProfessionalInfoResponseDto): ProfessionalInfoResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.professionalInfoDocuments)) {
    data["professionalInfoDocuments"] = _data.professionalInfoDocuments.map(item => 
        prepareSerializeProfessionalInfoDocument(item)
    );
  }
  return data as ProfessionalInfoResponseDto;
}
export interface ProfessionalInfoDocument  {
  name: string;
  validFrom: Date;
  link: string;
}
export function deserializeProfessionalInfoDocument(json: string): ProfessionalInfoDocument {
  const data = JSON.parse(json) as ProfessionalInfoDocument;
  initProfessionalInfoDocument(data);
  return data;
}
export function initProfessionalInfoDocument(_data: ProfessionalInfoDocument) {
  if (_data) {
    _data.validFrom = _data["validFrom"] ? parseDateOnly(_data["validFrom"].toString()) : <any>null;
  }
  return _data;
}
export function serializeProfessionalInfoDocument(_data: ProfessionalInfoDocument | undefined) {
  if (_data) {
    _data = prepareSerializeProfessionalInfoDocument(_data as ProfessionalInfoDocument);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProfessionalInfoDocument(_data: ProfessionalInfoDocument): ProfessionalInfoDocument {
  const data: Record<string, any> = { ..._data };
  data["validFrom"] = _data.validFrom && formatDate(_data.validFrom);
  return data as ProfessionalInfoDocument;
}
export enum DeviceBrand {
    All = "All",
    CARO = "CARO",
    LUISA = "LUISA",
    PrismaSMART = "prismaSMART",
    PrismaVENT = "prismaVENT",
    PrismaLINE = "prismaLINE",
    Other = "Other",
}
export interface PriceListsResponseDto  {
  lastValid: Date | null;
  records: { [key: string]: PriceList[]; };
}
export function deserializePriceListsResponseDto(json: string): PriceListsResponseDto {
  const data = JSON.parse(json) as PriceListsResponseDto;
  initPriceListsResponseDto(data);
  return data;
}
export function initPriceListsResponseDto(_data: PriceListsResponseDto) {
  if (_data) {
    _data.lastValid = _data["lastValid"] ? parseDateOnly(_data["lastValid"].toString()) : <any>null;
  }
  return _data;
}
export function serializePriceListsResponseDto(_data: PriceListsResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializePriceListsResponseDto(_data as PriceListsResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePriceListsResponseDto(_data: PriceListsResponseDto): PriceListsResponseDto {
  const data: Record<string, any> = { ..._data };
  data["lastValid"] = _data.lastValid && formatDate(_data.lastValid);
  return data as PriceListsResponseDto;
}
export interface PriceList  {
  name: string;
  linkPdf: string;
  linkCsv: string;
}
export function deserializePriceList(json: string): PriceList {
  const data = JSON.parse(json) as PriceList;
  initPriceList(data);
  return data;
}
export function initPriceList(_data: PriceList) {
    return _data;
}
export function serializePriceList(_data: PriceList | undefined) {
  if (_data) {
    _data = prepareSerializePriceList(_data as PriceList);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePriceList(_data: PriceList): PriceList {
  const data: Record<string, any> = { ..._data };
  return data as PriceList;
}
export interface PriceListsRequestDto  {
}
export function deserializePriceListsRequestDto(json: string): PriceListsRequestDto {
  const data = JSON.parse(json) as PriceListsRequestDto;
  initPriceListsRequestDto(data);
  return data;
}
export function initPriceListsRequestDto(_data: PriceListsRequestDto) {
  return _data;
}
export function serializePriceListsRequestDto(_data: PriceListsRequestDto | undefined) {
  if (_data) {
    _data = prepareSerializePriceListsRequestDto(_data as PriceListsRequestDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePriceListsRequestDto(_data: PriceListsRequestDto): PriceListsRequestDto {
  const data: Record<string, any> = { ..._data };
  return data as PriceListsRequestDto;
}
export interface AbasExecuteResponse  {
  meta: AbasQueryResponseMeta;
  content: ExecuteResponseContent;
  protocolVersion: string;
}
export function deserializeAbasExecuteResponse(json: string): AbasExecuteResponse {
  const data = JSON.parse(json) as AbasExecuteResponse;
  initAbasExecuteResponse(data);
  return data;
}
export function initAbasExecuteResponse(_data: AbasExecuteResponse) {
  if (_data) {
    _data.meta = _data["meta"] && initAbasQueryResponseMeta(_data["meta"]);
    _data.content = _data["content"] && initExecuteResponseContent(_data["content"]);
  }
  return _data;
}
export function serializeAbasExecuteResponse(_data: AbasExecuteResponse | undefined) {
  if (_data) {
    _data = prepareSerializeAbasExecuteResponse(_data as AbasExecuteResponse);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasExecuteResponse(_data: AbasExecuteResponse): AbasExecuteResponse {
  const data: Record<string, any> = { ..._data };
  data["meta"] = _data.meta && prepareSerializeAbasQueryResponseMeta(_data.meta);
  data["content"] = _data.content && prepareSerializeExecuteResponseContent(_data.content);
  return data as AbasExecuteResponse;
}
export interface AbasQueryResponseMeta  {
  contentType: string;
  _type: string;
  sourceType: string;
  objectType: string;
  client: string;
  schemaVersion: string;
  group: string;
  objectGroup: string;
  id: string;
  identNumber: string;
  version: string;
  lastModified: Date;
  tag: string;
  rowCount: number;
  tableOffset: number;
  tableLimit: number;
  link: AbasQueryLink;
}
export function deserializeAbasQueryResponseMeta(json: string): AbasQueryResponseMeta {
  const data = JSON.parse(json) as AbasQueryResponseMeta;
  initAbasQueryResponseMeta(data);
  return data;
}
export function initAbasQueryResponseMeta(_data: AbasQueryResponseMeta) {
  if (_data) {
    _data.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>null;
    _data.link = _data["link"] && initAbasQueryLink(_data["link"]);
  }
  return _data;
}
export function serializeAbasQueryResponseMeta(_data: AbasQueryResponseMeta | undefined) {
  if (_data) {
    _data = prepareSerializeAbasQueryResponseMeta(_data as AbasQueryResponseMeta);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasQueryResponseMeta(_data: AbasQueryResponseMeta): AbasQueryResponseMeta {
  const data: Record<string, any> = { ..._data };
  data["lastModified"] = _data.lastModified && _data.lastModified.toISOString();
  data["link"] = _data.link && prepareSerializeAbasQueryLink(_data.link);
  return data as AbasQueryResponseMeta;
}
export interface ExecuteResponseContent  {
  type: string;
  data: AbasErpDataObject;
  messages: ErpMessage[];
  document: ErpDocument | null;
  printer: ErpPrinter | null;
}
export function deserializeExecuteResponseContent(json: string): ExecuteResponseContent {
  const data = JSON.parse(json) as ExecuteResponseContent;
  initExecuteResponseContent(data);
  return data;
}
export function initExecuteResponseContent(_data: ExecuteResponseContent) {
  if (_data) {
    _data.data = _data["data"] && initAbasErpDataObject(_data["data"]);
    if (Array.isArray(_data["messages"])) {
      _data.messages = _data["messages"].map(item => 
        initErpMessage(item)
      );
    }
    _data.document = _data["document"] && initErpDocument(_data["document"]);
    _data.printer = _data["printer"] && initErpPrinter(_data["printer"]);
  }
  return _data;
}
export function serializeExecuteResponseContent(_data: ExecuteResponseContent | undefined) {
  if (_data) {
    _data = prepareSerializeExecuteResponseContent(_data as ExecuteResponseContent);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeExecuteResponseContent(_data: ExecuteResponseContent): ExecuteResponseContent {
  const data: Record<string, any> = { ..._data };
  data["data"] = _data.data && prepareSerializeAbasErpDataObject(_data.data);
  if (Array.isArray(_data.messages)) {
    data["messages"] = _data.messages.map(item => 
        prepareSerializeErpMessage(item)
    );
  }
  data["document"] = _data.document && prepareSerializeErpDocument(_data.document);
  data["printer"] = _data.printer && prepareSerializeErpPrinter(_data.printer);
  return data as ExecuteResponseContent;
}
export interface AbasErpDataObject  {
  meta: AbasQueryResponseMeta;
  links: { [key: string]: AbasQueryLink[]; };
  head: AbasErpDataHead;
  table: AbasErpDataTableItem[] | null;
  erpDataObjects: AbasErpDataObject[];
}
export function deserializeAbasErpDataObject(json: string): AbasErpDataObject {
  const data = JSON.parse(json) as AbasErpDataObject;
  initAbasErpDataObject(data);
  return data;
}
export function initAbasErpDataObject(_data: AbasErpDataObject) {
  if (_data) {
    _data.meta = _data["meta"] && initAbasQueryResponseMeta(_data["meta"]);
    _data.head = _data["head"] && initAbasErpDataHead(_data["head"]);
    if (Array.isArray(_data["table"])) {
      _data.table = _data["table"].map(item => 
        initAbasErpDataTableItem(item)
      );
    }
    if (Array.isArray(_data["erpDataObjects"])) {
      _data.erpDataObjects = _data["erpDataObjects"].map(item => 
        initAbasErpDataObject(item)
      );
    }
  }
  return _data;
}
export function serializeAbasErpDataObject(_data: AbasErpDataObject | undefined) {
  if (_data) {
    _data = prepareSerializeAbasErpDataObject(_data as AbasErpDataObject);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasErpDataObject(_data: AbasErpDataObject): AbasErpDataObject {
  const data: Record<string, any> = { ..._data };
  data["meta"] = _data.meta && prepareSerializeAbasQueryResponseMeta(_data.meta);
  data["head"] = _data.head && prepareSerializeAbasErpDataHead(_data.head);
  if (Array.isArray(_data.table)) {
    data["table"] = _data.table.map(item => 
        prepareSerializeAbasErpDataTableItem(item)
    );
  }
  if (Array.isArray(_data.erpDataObjects)) {
    data["erpDataObjects"] = _data.erpDataObjects.map(item => 
        prepareSerializeAbasErpDataObject(item)
    );
  }
  return data as AbasErpDataObject;
}
export interface AbasErpDataHead  {
  fields: { [key: string]: QueryResponseField; };
}
export function deserializeAbasErpDataHead(json: string): AbasErpDataHead {
  const data = JSON.parse(json) as AbasErpDataHead;
  initAbasErpDataHead(data);
  return data;
}
export function initAbasErpDataHead(_data: AbasErpDataHead) {
    return _data;
}
export function serializeAbasErpDataHead(_data: AbasErpDataHead | undefined) {
  if (_data) {
    _data = prepareSerializeAbasErpDataHead(_data as AbasErpDataHead);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasErpDataHead(_data: AbasErpDataHead): AbasErpDataHead {
  const data: Record<string, any> = { ..._data };
  if (_data.fields) {
    for (let key in _data.fields) {
            (<any>data["fields"])[key] = _data.fields[key] && prepareSerializeQueryResponseField(_data.fields[key]);
    }
}
  return data as AbasErpDataHead;
}
export interface ErpMessage  {
  text: string[];
  type: string;
  subType: string;
  fieldNames: string[];
  rowSpec: string;
  value: string;
}
export function deserializeErpMessage(json: string): ErpMessage {
  const data = JSON.parse(json) as ErpMessage;
  initErpMessage(data);
  return data;
}
export function initErpMessage(_data: ErpMessage) {
  if (_data) {
    _data.text = _data["text"];
    _data.fieldNames = _data["fieldNames"];
  }
  return _data;
}
export function serializeErpMessage(_data: ErpMessage | undefined) {
  if (_data) {
    _data = prepareSerializeErpMessage(_data as ErpMessage);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeErpMessage(_data: ErpMessage): ErpMessage {
  const data: Record<string, any> = { ..._data };
  return data as ErpMessage;
}
export interface ErpDocument  {
  id: string;
  link: ErpDocumentLink | null;
  fileName: string;
  mimeType: string;
  sizeInBytes: number;
}
export function deserializeErpDocument(json: string): ErpDocument {
  const data = JSON.parse(json) as ErpDocument;
  initErpDocument(data);
  return data;
}
export function initErpDocument(_data: ErpDocument) {
  if (_data) {
    _data.link = _data["link"] && initErpDocumentLink(_data["link"]);
  }
  return _data;
}
export function serializeErpDocument(_data: ErpDocument | undefined) {
  if (_data) {
    _data = prepareSerializeErpDocument(_data as ErpDocument);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeErpDocument(_data: ErpDocument): ErpDocument {
  const data: Record<string, any> = { ..._data };
  data["link"] = _data.link && prepareSerializeErpDocumentLink(_data.link);
  return data as ErpDocument;
}
export interface ErpDocumentLink  {
  rel: string;
  href: string;
  objectType: string;
}
export function deserializeErpDocumentLink(json: string): ErpDocumentLink {
  const data = JSON.parse(json) as ErpDocumentLink;
  initErpDocumentLink(data);
  return data;
}
export function initErpDocumentLink(_data: ErpDocumentLink) {
    return _data;
}
export function serializeErpDocumentLink(_data: ErpDocumentLink | undefined) {
  if (_data) {
    _data = prepareSerializeErpDocumentLink(_data as ErpDocumentLink);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeErpDocumentLink(_data: ErpDocumentLink): ErpDocumentLink {
  const data: Record<string, any> = { ..._data };
  return data as ErpDocumentLink;
}
export interface ErpPrinter  {
  id: string;
  type: string;
  name: string;
}
export function deserializeErpPrinter(json: string): ErpPrinter {
  const data = JSON.parse(json) as ErpPrinter;
  initErpPrinter(data);
  return data;
}
export function initErpPrinter(_data: ErpPrinter) {
    return _data;
}
export function serializeErpPrinter(_data: ErpPrinter | undefined) {
  if (_data) {
    _data = prepareSerializeErpPrinter(_data as ErpPrinter);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeErpPrinter(_data: ErpPrinter): ErpPrinter {
  const data: Record<string, any> = { ..._data };
  return data as ErpPrinter;
}
export interface OutstandingReceivablesResponseDto  {
  totalSum: number | null;
  generalStatus: InvoiceStatus | null;
  countOfRecords: number | null;
  records: OutstandingReceivablesRecord[];
}
export function deserializeOutstandingReceivablesResponseDto(json: string): OutstandingReceivablesResponseDto {
  const data = JSON.parse(json) as OutstandingReceivablesResponseDto;
  initOutstandingReceivablesResponseDto(data);
  return data;
}
export function initOutstandingReceivablesResponseDto(_data: OutstandingReceivablesResponseDto) {
  if (_data) {
    _data.generalStatus = _data["generalStatus"];
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initOutstandingReceivablesRecord(item)
      );
    }
  }
  return _data;
}
export function serializeOutstandingReceivablesResponseDto(_data: OutstandingReceivablesResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeOutstandingReceivablesResponseDto(_data as OutstandingReceivablesResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeOutstandingReceivablesResponseDto(_data: OutstandingReceivablesResponseDto): OutstandingReceivablesResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeOutstandingReceivablesRecord(item)
    );
  }
  return data as OutstandingReceivablesResponseDto;
}
/** Values are used for calculating general status and sorting. */
export enum InvoiceStatus {
    OverdueDebt = "OverdueDebt",
    Debt = "Debt",
    Credited = "Credited",
    Repaid = "Repaid",
}
export interface OutstandingReceivablesRecord  {
  invoiceNumber: string;
  dated: Date;
  dueDate: Date;
  open: number;
  currency: string;
  invoiceAmount: number;
  dunningLevel: number;
  invoiceStatus: InvoiceStatus;
}
export function deserializeOutstandingReceivablesRecord(json: string): OutstandingReceivablesRecord {
  const data = JSON.parse(json) as OutstandingReceivablesRecord;
  initOutstandingReceivablesRecord(data);
  return data;
}
export function initOutstandingReceivablesRecord(_data: OutstandingReceivablesRecord) {
  if (_data) {
    _data.dated = _data["dated"] ? parseDateOnly(_data["dated"].toString()) : <any>null;
    _data.dueDate = _data["dueDate"] ? parseDateOnly(_data["dueDate"].toString()) : <any>null;
    _data.invoiceStatus = _data["invoiceStatus"];
  }
  return _data;
}
export function serializeOutstandingReceivablesRecord(_data: OutstandingReceivablesRecord | undefined) {
  if (_data) {
    _data = prepareSerializeOutstandingReceivablesRecord(_data as OutstandingReceivablesRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeOutstandingReceivablesRecord(_data: OutstandingReceivablesRecord): OutstandingReceivablesRecord {
  const data: Record<string, any> = { ..._data };
  data["dated"] = _data.dated && formatDate(_data.dated);
  data["dueDate"] = _data.dueDate && formatDate(_data.dueDate);
  return data as OutstandingReceivablesRecord;
}
export interface ResponseOrderListDto  {
  records: OrderListRecord[];
  countOfRecords: number;
}
export function deserializeResponseOrderListDto(json: string): ResponseOrderListDto {
  const data = JSON.parse(json) as ResponseOrderListDto;
  initResponseOrderListDto(data);
  return data;
}
export function initResponseOrderListDto(_data: ResponseOrderListDto) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initOrderListRecord(item)
      );
    }
  }
  return _data;
}
export function serializeResponseOrderListDto(_data: ResponseOrderListDto | undefined) {
  if (_data) {
    _data = prepareSerializeResponseOrderListDto(_data as ResponseOrderListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeResponseOrderListDto(_data: ResponseOrderListDto): ResponseOrderListDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeOrderListRecord(item)
    );
  }
  return data as ResponseOrderListDto;
}
export interface OrderListRecord  {
  order: string;
  from: Date | null;
  yourOrder: string;
  yourReference: string;
  earliestDeliveryDate: Date | null;
  latestDeliveryDate: Date | null;
  quantity: number | null;
  innerTable: OrderListInnerRecord[];
}
export function deserializeOrderListRecord(json: string): OrderListRecord {
  const data = JSON.parse(json) as OrderListRecord;
  initOrderListRecord(data);
  return data;
}
export function initOrderListRecord(_data: OrderListRecord) {
  if (_data) {
    _data.from = _data["from"] ? parseDateOnly(_data["from"].toString()) : <any>null;
    _data.earliestDeliveryDate = _data["earliestDeliveryDate"] ? parseDateOnly(_data["earliestDeliveryDate"].toString()) : <any>null;
    _data.latestDeliveryDate = _data["latestDeliveryDate"] ? parseDateOnly(_data["latestDeliveryDate"].toString()) : <any>null;
    if (Array.isArray(_data["innerTable"])) {
      _data.innerTable = _data["innerTable"].map(item => 
        initOrderListInnerRecord(item)
      );
    }
  }
  return _data;
}
export function serializeOrderListRecord(_data: OrderListRecord | undefined) {
  if (_data) {
    _data = prepareSerializeOrderListRecord(_data as OrderListRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeOrderListRecord(_data: OrderListRecord): OrderListRecord {
  const data: Record<string, any> = { ..._data };
  data["from"] = _data.from && formatDate(_data.from);
  data["earliestDeliveryDate"] = _data.earliestDeliveryDate && formatDate(_data.earliestDeliveryDate);
  data["latestDeliveryDate"] = _data.latestDeliveryDate && formatDate(_data.latestDeliveryDate);
  if (Array.isArray(_data.innerTable)) {
    data["innerTable"] = _data.innerTable.map(item => 
        prepareSerializeOrderListInnerRecord(item)
    );
  }
  return data as OrderListRecord;
}
export interface OrderListInnerRecord  {
  article: string;
  name: string;
  deliveryDate: Date | null;
  quantity: number | null;
}
export function deserializeOrderListInnerRecord(json: string): OrderListInnerRecord {
  const data = JSON.parse(json) as OrderListInnerRecord;
  initOrderListInnerRecord(data);
  return data;
}
export function initOrderListInnerRecord(_data: OrderListInnerRecord) {
  if (_data) {
    _data.deliveryDate = _data["deliveryDate"] ? parseDateOnly(_data["deliveryDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeOrderListInnerRecord(_data: OrderListInnerRecord | undefined) {
  if (_data) {
    _data = prepareSerializeOrderListInnerRecord(_data as OrderListInnerRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeOrderListInnerRecord(_data: OrderListInnerRecord): OrderListInnerRecord {
  const data: Record<string, any> = { ..._data };
  data["deliveryDate"] = _data.deliveryDate && formatDate(_data.deliveryDate);
  return data as OrderListInnerRecord;
}
export interface GetNotificationsResponseDto  {
  id: number;
  title: string;
  text: string;
  url: string | null;
  notificationParams: { [key: string]: any; } | null;
  type: NotificationType;
  createdDate: Date;
}
export function deserializeGetNotificationsResponseDto(json: string): GetNotificationsResponseDto {
  const data = JSON.parse(json) as GetNotificationsResponseDto;
  initGetNotificationsResponseDto(data);
  return data;
}
export function initGetNotificationsResponseDto(_data: GetNotificationsResponseDto) {
  if (_data) {
    _data.type = _data["type"];
    _data.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeGetNotificationsResponseDto(_data: GetNotificationsResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeGetNotificationsResponseDto(_data as GetNotificationsResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGetNotificationsResponseDto(_data: GetNotificationsResponseDto): GetNotificationsResponseDto {
  const data: Record<string, any> = { ..._data };
  data["createdDate"] = _data.createdDate && _data.createdDate.toISOString();
  return data as GetNotificationsResponseDto;
}
export enum NotificationType {
    Firmware = "Firmware",
    Bucharest = "Bucharest",
    Qualifications = "Qualifications",
    WarrantyRequests = "WarrantyRequests",
    Repairs = "Repairs",
}
export interface KonditionsBlattResponseDto  {
  countOfRecordWithFilters: number;
  records: KonditionsBlattRecord[];
}
export function deserializeKonditionsBlattResponseDto(json: string): KonditionsBlattResponseDto {
  const data = JSON.parse(json) as KonditionsBlattResponseDto;
  initKonditionsBlattResponseDto(data);
  return data;
}
export function initKonditionsBlattResponseDto(_data: KonditionsBlattResponseDto) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initKonditionsBlattRecord(item)
      );
    }
  }
  return _data;
}
export function serializeKonditionsBlattResponseDto(_data: KonditionsBlattResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeKonditionsBlattResponseDto(_data as KonditionsBlattResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeKonditionsBlattResponseDto(_data: KonditionsBlattResponseDto): KonditionsBlattResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeKonditionsBlattRecord(item)
    );
  }
  return data as KonditionsBlattResponseDto;
}
export interface KonditionsBlattRecord  {
  name: string;
  validFrom: Date;
  link: string;
}
export function deserializeKonditionsBlattRecord(json: string): KonditionsBlattRecord {
  const data = JSON.parse(json) as KonditionsBlattRecord;
  initKonditionsBlattRecord(data);
  return data;
}
export function initKonditionsBlattRecord(_data: KonditionsBlattRecord) {
  if (_data) {
    _data.validFrom = _data["validFrom"] ? parseDateOnly(_data["validFrom"].toString()) : <any>null;
  }
  return _data;
}
export function serializeKonditionsBlattRecord(_data: KonditionsBlattRecord | undefined) {
  if (_data) {
    _data = prepareSerializeKonditionsBlattRecord(_data as KonditionsBlattRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeKonditionsBlattRecord(_data: KonditionsBlattRecord): KonditionsBlattRecord {
  const data: Record<string, any> = { ..._data };
  data["validFrom"] = _data.validFrom && formatDate(_data.validFrom);
  return data as KonditionsBlattRecord;
}
export interface FwResponseDto  {
  exists: boolean;
  deviceGeneration: string;
  subtype: string | null;
  availableUpdates: AvailableUpdate[];
  version: string | null;
  releaseDate: Date | null;
}
export function deserializeFwResponseDto(json: string): FwResponseDto {
  const data = JSON.parse(json) as FwResponseDto;
  initFwResponseDto(data);
  return data;
}
export function initFwResponseDto(_data: FwResponseDto) {
  if (_data) {
    if (Array.isArray(_data["availableUpdates"])) {
      _data.availableUpdates = _data["availableUpdates"].map(item => 
        initAvailableUpdate(item)
      );
    }
    _data.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeFwResponseDto(_data: FwResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeFwResponseDto(_data as FwResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFwResponseDto(_data: FwResponseDto): FwResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.availableUpdates)) {
    data["availableUpdates"] = _data.availableUpdates.map(item => 
        prepareSerializeAvailableUpdate(item)
    );
  }
  data["releaseDate"] = _data.releaseDate && _data.releaseDate.toISOString();
  return data as FwResponseDto;
}
export interface AvailableUpdate  {
  version: string | null;
  releaseNotes: string | null;
  releaseDate: Date | null;
}
export function deserializeAvailableUpdate(json: string): AvailableUpdate {
  const data = JSON.parse(json) as AvailableUpdate;
  initAvailableUpdate(data);
  return data;
}
export function initAvailableUpdate(_data: AvailableUpdate) {
  if (_data) {
    _data.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeAvailableUpdate(_data: AvailableUpdate | undefined) {
  if (_data) {
    _data = prepareSerializeAvailableUpdate(_data as AvailableUpdate);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAvailableUpdate(_data: AvailableUpdate): AvailableUpdate {
  const data: Record<string, any> = { ..._data };
  data["releaseDate"] = _data.releaseDate && _data.releaseDate.toISOString();
  return data as AvailableUpdate;
}
export interface FileInfoDto  {
  id: string;
  fileName: string;
  size: number;
  metadata: FileMetadataDto;
  createdAt: Date;
  /** Contains Sharepoint file path if the file is from Sharepoint */
  externalFilePath: string;
}
export function deserializeFileInfoDto(json: string): FileInfoDto {
  const data = JSON.parse(json) as FileInfoDto;
  initFileInfoDto(data);
  return data;
}
export function initFileInfoDto(_data: FileInfoDto) {
  if (_data) {
    _data.metadata = _data["metadata"] && initFileMetadataDto(_data["metadata"]);
    _data.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializeFileInfoDto(_data: FileInfoDto | undefined) {
  if (_data) {
    _data = prepareSerializeFileInfoDto(_data as FileInfoDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFileInfoDto(_data: FileInfoDto): FileInfoDto {
  const data: Record<string, any> = { ..._data };
  data["metadata"] = _data.metadata && prepareSerializeFileMetadataDto(_data.metadata);
  data["createdAt"] = _data.createdAt && _data.createdAt.toISOString();
  return data as FileInfoDto;
}
export interface FileMetadataDto  {
  isSharepoint: boolean | null;
  externalId: string | null;
}
export function deserializeFileMetadataDto(json: string): FileMetadataDto {
  const data = JSON.parse(json) as FileMetadataDto;
  initFileMetadataDto(data);
  return data;
}
export function initFileMetadataDto(_data: FileMetadataDto) {
    return _data;
}
export function serializeFileMetadataDto(_data: FileMetadataDto | undefined) {
  if (_data) {
    _data = prepareSerializeFileMetadataDto(_data as FileMetadataDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFileMetadataDto(_data: FileMetadataDto): FileMetadataDto {
  const data: Record<string, any> = { ..._data };
  return data as FileMetadataDto;
}
export interface UploadSharepointFileDto  {
  url: string;
  /** Could be used to identify the id of original file when it was imported from somewhere.
UseCase1: save PROD's file Id when copying files from PROD to DEV/GREEN */
  externalId: string | null;
}
export function deserializeUploadSharepointFileDto(json: string): UploadSharepointFileDto {
  const data = JSON.parse(json) as UploadSharepointFileDto;
  initUploadSharepointFileDto(data);
  return data;
}
export function initUploadSharepointFileDto(_data: UploadSharepointFileDto) {
    return _data;
}
export function serializeUploadSharepointFileDto(_data: UploadSharepointFileDto | undefined) {
  if (_data) {
    _data = prepareSerializeUploadSharepointFileDto(_data as UploadSharepointFileDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUploadSharepointFileDto(_data: UploadSharepointFileDto): UploadSharepointFileDto {
  const data: Record<string, any> = { ..._data };
  return data as UploadSharepointFileDto;
}
export interface PagedResultOfFileInfoDto  {
  data: FileInfoDto[];
  totalCount: number;
}
export function deserializePagedResultOfFileInfoDto(json: string): PagedResultOfFileInfoDto {
  const data = JSON.parse(json) as PagedResultOfFileInfoDto;
  initPagedResultOfFileInfoDto(data);
  return data;
}
export function initPagedResultOfFileInfoDto(_data: PagedResultOfFileInfoDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initFileInfoDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfFileInfoDto(_data: PagedResultOfFileInfoDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfFileInfoDto(_data as PagedResultOfFileInfoDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfFileInfoDto(_data: PagedResultOfFileInfoDto): PagedResultOfFileInfoDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeFileInfoDto(item)
    );
  }
  return data as PagedResultOfFileInfoDto;
}
export interface ResponseDeviceOverview  {
  records: DeviceOverviewRecord[];
  countOfRecords: number;
}
export function deserializeResponseDeviceOverview(json: string): ResponseDeviceOverview {
  const data = JSON.parse(json) as ResponseDeviceOverview;
  initResponseDeviceOverview(data);
  return data;
}
export function initResponseDeviceOverview(_data: ResponseDeviceOverview) {
  if (_data) {
    if (Array.isArray(_data["records"])) {
      _data.records = _data["records"].map(item => 
        initDeviceOverviewRecord(item)
      );
    }
  }
  return _data;
}
export function serializeResponseDeviceOverview(_data: ResponseDeviceOverview | undefined) {
  if (_data) {
    _data = prepareSerializeResponseDeviceOverview(_data as ResponseDeviceOverview);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeResponseDeviceOverview(_data: ResponseDeviceOverview): ResponseDeviceOverview {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.records)) {
    data["records"] = _data.records.map(item => 
        prepareSerializeDeviceOverviewRecord(item)
    );
  }
  return data as ResponseDeviceOverview;
}
export interface DeviceOverviewRecord  {
  deviceNumber: string;
  description: string;
  placeOfLocation: string;
  yearOfManufacture: string;
  nextMaintenance: Date | null;
  typeOfMaintenance: number | null;
  orderNumber: number | null;
  shippingDate: Date | null;
}
export function deserializeDeviceOverviewRecord(json: string): DeviceOverviewRecord {
  const data = JSON.parse(json) as DeviceOverviewRecord;
  initDeviceOverviewRecord(data);
  return data;
}
export function initDeviceOverviewRecord(_data: DeviceOverviewRecord) {
  if (_data) {
    _data.nextMaintenance = _data["nextMaintenance"] ? parseDateOnly(_data["nextMaintenance"].toString()) : <any>null;
    _data.shippingDate = _data["shippingDate"] ? parseDateOnly(_data["shippingDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeDeviceOverviewRecord(_data: DeviceOverviewRecord | undefined) {
  if (_data) {
    _data = prepareSerializeDeviceOverviewRecord(_data as DeviceOverviewRecord);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDeviceOverviewRecord(_data: DeviceOverviewRecord): DeviceOverviewRecord {
  const data: Record<string, any> = { ..._data };
  data["nextMaintenance"] = _data.nextMaintenance && formatDate(_data.nextMaintenance);
  data["shippingDate"] = _data.shippingDate && formatDate(_data.shippingDate);
  return data as DeviceOverviewRecord;
}
export interface CustomerInfoDto  {
  customerNumber: string;
  organizationName: string;
  countryName: string;
  email: string;
  phoneNumber: string;
  companyFullName: string;
  street: string;
  postCode: string;
  countryCode: string;
  city: string;
}
export function deserializeCustomerInfoDto(json: string): CustomerInfoDto {
  const data = JSON.parse(json) as CustomerInfoDto;
  initCustomerInfoDto(data);
  return data;
}
export function initCustomerInfoDto(_data: CustomerInfoDto) {
    return _data;
}
export function serializeCustomerInfoDto(_data: CustomerInfoDto | undefined) {
  if (_data) {
    _data = prepareSerializeCustomerInfoDto(_data as CustomerInfoDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCustomerInfoDto(_data: CustomerInfoDto): CustomerInfoDto {
  const data: Record<string, any> = { ..._data };
  return data as CustomerInfoDto;
}
export interface PagedResultOfCmsPageListItemDto  {
  data: CmsPageListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfCmsPageListItemDto(json: string): PagedResultOfCmsPageListItemDto {
  const data = JSON.parse(json) as PagedResultOfCmsPageListItemDto;
  initPagedResultOfCmsPageListItemDto(data);
  return data;
}
export function initPagedResultOfCmsPageListItemDto(_data: PagedResultOfCmsPageListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initCmsPageListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfCmsPageListItemDto(_data: PagedResultOfCmsPageListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfCmsPageListItemDto(_data as PagedResultOfCmsPageListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfCmsPageListItemDto(_data: PagedResultOfCmsPageListItemDto): PagedResultOfCmsPageListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeCmsPageListItemDto(item)
    );
  }
  return data as PagedResultOfCmsPageListItemDto;
}
export interface CmsPageListItemDto  {
  id: number;
  title: string;
  url: string;
  showInMenu: boolean;
  updatedAt: Date | null;
}
export function deserializeCmsPageListItemDto(json: string): CmsPageListItemDto {
  const data = JSON.parse(json) as CmsPageListItemDto;
  initCmsPageListItemDto(data);
  return data;
}
export function initCmsPageListItemDto(_data: CmsPageListItemDto) {
  if (_data) {
    _data.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializeCmsPageListItemDto(_data: CmsPageListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeCmsPageListItemDto(_data as CmsPageListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCmsPageListItemDto(_data: CmsPageListItemDto): CmsPageListItemDto {
  const data: Record<string, any> = { ..._data };
  data["updatedAt"] = _data.updatedAt && _data.updatedAt.toISOString();
  return data as CmsPageListItemDto;
}
export interface CmsPageDto  {
  id: number;
  title: string;
  url: string;
  defaultLanguage: Language | null;
  showInMenu: boolean;
  hasPublishedVersion: boolean;
  allowedRoles: UserRole[];
  allowedCountries: string[];
  /** CmsPageVersion.Id */
  versionId: number;
  /** CmsPageVersion.Content (the content of the latest or published version) */
  content: string;
  /** CmsPageVersion.VersionNumber */
  versionNumber: number;
  /** CmsPageVersion.CreatedAt */
  contentLastUpdatedAt: Date;
  /** CmsPageVersion.IsAutosaved */
  isAutosaved: boolean;
  /** CmsPageVersion.CreatedBy */
  lastUpdatedBy: UserShortDto;
  titleTranslations: CmsTranslationDto[];
}
export function deserializeCmsPageDto(json: string): CmsPageDto {
  const data = JSON.parse(json) as CmsPageDto;
  initCmsPageDto(data);
  return data;
}
export function initCmsPageDto(_data: CmsPageDto) {
  if (_data) {
    _data.defaultLanguage = _data["defaultLanguage"];
    _data.allowedRoles = _data["allowedRoles"];
    _data.allowedCountries = _data["allowedCountries"];
    _data.contentLastUpdatedAt = _data["contentLastUpdatedAt"] ? new Date(_data["contentLastUpdatedAt"].toString()) : <any>null;
    _data.lastUpdatedBy = _data["lastUpdatedBy"] && initUserShortDto(_data["lastUpdatedBy"]);
    if (Array.isArray(_data["titleTranslations"])) {
      _data.titleTranslations = _data["titleTranslations"].map(item => 
        initCmsTranslationDto(item)
      );
    }
  }
  return _data;
}
export function serializeCmsPageDto(_data: CmsPageDto | undefined) {
  if (_data) {
    _data = prepareSerializeCmsPageDto(_data as CmsPageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCmsPageDto(_data: CmsPageDto): CmsPageDto {
  const data: Record<string, any> = { ..._data };
  data["contentLastUpdatedAt"] = _data.contentLastUpdatedAt && _data.contentLastUpdatedAt.toISOString();
  data["lastUpdatedBy"] = _data.lastUpdatedBy && prepareSerializeUserShortDto(_data.lastUpdatedBy);
  if (Array.isArray(_data.titleTranslations)) {
    data["titleTranslations"] = _data.titleTranslations.map(item => 
        prepareSerializeCmsTranslationDto(item)
    );
  }
  return data as CmsPageDto;
}
export enum Language {
    En = "En",
    De = "De",
    Fr = "Fr",
    Es = "Es",
}
export interface UserShortDto  {
  id: string;
  userName: string;
  firstName: string;
}
export function deserializeUserShortDto(json: string): UserShortDto {
  const data = JSON.parse(json) as UserShortDto;
  initUserShortDto(data);
  return data;
}
export function initUserShortDto(_data: UserShortDto) {
    return _data;
}
export function serializeUserShortDto(_data: UserShortDto | undefined) {
  if (_data) {
    _data = prepareSerializeUserShortDto(_data as UserShortDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUserShortDto(_data: UserShortDto): UserShortDto {
  const data: Record<string, any> = { ..._data };
  return data as UserShortDto;
}
export interface CmsTranslationDto  {
  language: Language;
  translatedText: string;
  isTranslationExpired: boolean;
}
export function deserializeCmsTranslationDto(json: string): CmsTranslationDto {
  const data = JSON.parse(json) as CmsTranslationDto;
  initCmsTranslationDto(data);
  return data;
}
export function initCmsTranslationDto(_data: CmsTranslationDto) {
  if (_data) {
    _data.language = _data["language"];
  }
  return _data;
}
export function serializeCmsTranslationDto(_data: CmsTranslationDto | undefined) {
  if (_data) {
    _data = prepareSerializeCmsTranslationDto(_data as CmsTranslationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCmsTranslationDto(_data: CmsTranslationDto): CmsTranslationDto {
  const data: Record<string, any> = { ..._data };
  return data as CmsTranslationDto;
}
export interface CreateCmsPageDto  {
  title: string;
  url: string;
  showInMenu: boolean;
  content: string;
}
export function deserializeCreateCmsPageDto(json: string): CreateCmsPageDto {
  const data = JSON.parse(json) as CreateCmsPageDto;
  initCreateCmsPageDto(data);
  return data;
}
export function initCreateCmsPageDto(_data: CreateCmsPageDto) {
    return _data;
}
export function serializeCreateCmsPageDto(_data: CreateCmsPageDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateCmsPageDto(_data as CreateCmsPageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateCmsPageDto(_data: CreateCmsPageDto): CreateCmsPageDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateCmsPageDto;
}
export interface PatchCmsPageDto  {
  title?: string;
  url?: string;
  showInMenu?: boolean;
  content?: string;
  defaultLanguage?: Language;
  allowedRoles?: UserRole[] | null;
  allowedCountries?: string[] | null;
}
export function deserializePatchCmsPageDto(json: string): PatchCmsPageDto {
  const data = JSON.parse(json) as PatchCmsPageDto;
  initPatchCmsPageDto(data);
  return data;
}
export function initPatchCmsPageDto(_data: PatchCmsPageDto) {
  if (_data) {
    _data.defaultLanguage = _data["defaultLanguage"];
    _data.allowedRoles = _data["allowedRoles"];
    _data.allowedCountries = _data["allowedCountries"];
  }
  return _data;
}
export function serializePatchCmsPageDto(_data: PatchCmsPageDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchCmsPageDto(_data as PatchCmsPageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchCmsPageDto(_data: PatchCmsPageDto): PatchCmsPageDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchCmsPageDto;
}
export interface PagedResultOfCmsPageVersionDto  {
  data: CmsPageVersionDto[];
  totalCount: number;
}
export function deserializePagedResultOfCmsPageVersionDto(json: string): PagedResultOfCmsPageVersionDto {
  const data = JSON.parse(json) as PagedResultOfCmsPageVersionDto;
  initPagedResultOfCmsPageVersionDto(data);
  return data;
}
export function initPagedResultOfCmsPageVersionDto(_data: PagedResultOfCmsPageVersionDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initCmsPageVersionDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfCmsPageVersionDto(_data: PagedResultOfCmsPageVersionDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfCmsPageVersionDto(_data as PagedResultOfCmsPageVersionDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfCmsPageVersionDto(_data: PagedResultOfCmsPageVersionDto): PagedResultOfCmsPageVersionDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeCmsPageVersionDto(item)
    );
  }
  return data as PagedResultOfCmsPageVersionDto;
}
export interface CmsPageVersionDto  {
  id: number;
  cmsPage: CmsPageListItemDto;
  versionNumber: number;
  createdAt: Date;
  createdBy: UserShortDto;
  isPublished: boolean;
  isAutosaved: boolean;
}
export function deserializeCmsPageVersionDto(json: string): CmsPageVersionDto {
  const data = JSON.parse(json) as CmsPageVersionDto;
  initCmsPageVersionDto(data);
  return data;
}
export function initCmsPageVersionDto(_data: CmsPageVersionDto) {
  if (_data) {
    _data.cmsPage = _data["cmsPage"] && initCmsPageListItemDto(_data["cmsPage"]);
    _data.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
    _data.createdBy = _data["createdBy"] && initUserShortDto(_data["createdBy"]);
  }
  return _data;
}
export function serializeCmsPageVersionDto(_data: CmsPageVersionDto | undefined) {
  if (_data) {
    _data = prepareSerializeCmsPageVersionDto(_data as CmsPageVersionDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCmsPageVersionDto(_data: CmsPageVersionDto): CmsPageVersionDto {
  const data: Record<string, any> = { ..._data };
  data["cmsPage"] = _data.cmsPage && prepareSerializeCmsPageListItemDto(_data.cmsPage);
  data["createdAt"] = _data.createdAt && _data.createdAt.toISOString();
  data["createdBy"] = _data.createdBy && prepareSerializeUserShortDto(_data.createdBy);
  return data as CmsPageVersionDto;
}
export interface CmsPageVersionDetailedDto  {
  id: number;
  cmsPage: CmsPageListItemDto;
  versionNumber: number;
  createdAt: Date;
  createdBy: UserShortDto;
  content: string;
  isAutosaved: boolean;
}
export function deserializeCmsPageVersionDetailedDto(json: string): CmsPageVersionDetailedDto {
  const data = JSON.parse(json) as CmsPageVersionDetailedDto;
  initCmsPageVersionDetailedDto(data);
  return data;
}
export function initCmsPageVersionDetailedDto(_data: CmsPageVersionDetailedDto) {
  if (_data) {
    _data.cmsPage = _data["cmsPage"] && initCmsPageListItemDto(_data["cmsPage"]);
    _data.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
    _data.createdBy = _data["createdBy"] && initUserShortDto(_data["createdBy"]);
  }
  return _data;
}
export function serializeCmsPageVersionDetailedDto(_data: CmsPageVersionDetailedDto | undefined) {
  if (_data) {
    _data = prepareSerializeCmsPageVersionDetailedDto(_data as CmsPageVersionDetailedDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCmsPageVersionDetailedDto(_data: CmsPageVersionDetailedDto): CmsPageVersionDetailedDto {
  const data: Record<string, any> = { ..._data };
  data["cmsPage"] = _data.cmsPage && prepareSerializeCmsPageListItemDto(_data.cmsPage);
  data["createdAt"] = _data.createdAt && _data.createdAt.toISOString();
  data["createdBy"] = _data.createdBy && prepareSerializeUserShortDto(_data.createdBy);
  return data as CmsPageVersionDetailedDto;
}
export interface StartReplacementOperationResponseDto  {
  status: StartReplacementStatus;
  pkiReplacementOperationId: number | null;
  originalOperationCreatedAt: Date | null;
  requestId: string | null;
  errorMessage: string | null;
}
export function deserializeStartReplacementOperationResponseDto(json: string): StartReplacementOperationResponseDto {
  const data = JSON.parse(json) as StartReplacementOperationResponseDto;
  initStartReplacementOperationResponseDto(data);
  return data;
}
export function initStartReplacementOperationResponseDto(_data: StartReplacementOperationResponseDto) {
  if (_data) {
    _data.status = _data["status"];
    _data.originalOperationCreatedAt = _data["originalOperationCreatedAt"] ? new Date(_data["originalOperationCreatedAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializeStartReplacementOperationResponseDto(_data: StartReplacementOperationResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeStartReplacementOperationResponseDto(_data as StartReplacementOperationResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeStartReplacementOperationResponseDto(_data: StartReplacementOperationResponseDto): StartReplacementOperationResponseDto {
  const data: Record<string, any> = { ..._data };
  data["originalOperationCreatedAt"] = _data.originalOperationCreatedAt && _data.originalOperationCreatedAt.toISOString();
  return data as StartReplacementOperationResponseDto;
}
export enum StartReplacementStatus {
    Success = "Success",
    Failure = "Failure",
    Duplicated = "Duplicated",
}
export interface ReplacementResponseDto  {
  status: ReplacementStatus;
  serialNumber: string | null;
  certificateFileName: string | null;
  operationId: number | null;
  iccid: string | null;
  imei: string | null;
  requestId: string | null;
  pkiTraceId: string | null;
  errorMessage: string | null;
}
export function deserializeReplacementResponseDto(json: string): ReplacementResponseDto {
  const data = JSON.parse(json) as ReplacementResponseDto;
  initReplacementResponseDto(data);
  return data;
}
export function initReplacementResponseDto(_data: ReplacementResponseDto) {
  if (_data) {
    _data.status = _data["status"];
  }
  return _data;
}
export function serializeReplacementResponseDto(_data: ReplacementResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeReplacementResponseDto(_data as ReplacementResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeReplacementResponseDto(_data: ReplacementResponseDto): ReplacementResponseDto {
  const data: Record<string, any> = { ..._data };
  return data as ReplacementResponseDto;
}
export enum ReplacementStatus {
    Success = "Success",
    Pending = "Pending",
    Failure = "Failure",
}
export interface AbasFileResponseDto  {
  countOfRecords: number;
  fileGroups: AbasFileGroupDto[];
}
export function deserializeAbasFileResponseDto(json: string): AbasFileResponseDto {
  const data = JSON.parse(json) as AbasFileResponseDto;
  initAbasFileResponseDto(data);
  return data;
}
export function initAbasFileResponseDto(_data: AbasFileResponseDto) {
  if (_data) {
    if (Array.isArray(_data["fileGroups"])) {
      _data.fileGroups = _data["fileGroups"].map(item => 
        initAbasFileGroupDto(item)
      );
    }
  }
  return _data;
}
export function serializeAbasFileResponseDto(_data: AbasFileResponseDto | undefined) {
  if (_data) {
    _data = prepareSerializeAbasFileResponseDto(_data as AbasFileResponseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasFileResponseDto(_data: AbasFileResponseDto): AbasFileResponseDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.fileGroups)) {
    data["fileGroups"] = _data.fileGroups.map(item => 
        prepareSerializeAbasFileGroupDto(item)
    );
  }
  return data as AbasFileResponseDto;
}
export interface AbasFileGroupDto  {
  infosystemTypeName: string;
  files: AbasFileSearchResultDto[];
}
export function deserializeAbasFileGroupDto(json: string): AbasFileGroupDto {
  const data = JSON.parse(json) as AbasFileGroupDto;
  initAbasFileGroupDto(data);
  return data;
}
export function initAbasFileGroupDto(_data: AbasFileGroupDto) {
  if (_data) {
    if (Array.isArray(_data["files"])) {
      _data.files = _data["files"].map(item => 
        initAbasFileSearchResultDto(item)
      );
    }
  }
  return _data;
}
export function serializeAbasFileGroupDto(_data: AbasFileGroupDto | undefined) {
  if (_data) {
    _data = prepareSerializeAbasFileGroupDto(_data as AbasFileGroupDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasFileGroupDto(_data: AbasFileGroupDto): AbasFileGroupDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.files)) {
    data["files"] = _data.files.map(item => 
        prepareSerializeAbasFileSearchResultDto(item)
    );
  }
  return data as AbasFileGroupDto;
}
export interface AbasFileSearchResultDto  {
  id: string;
  infosystemType: string;
  infosystemTypeName: string;
  fileName: string;
  fileLink: string;
  existsOnSharePoint: boolean;
}
export function deserializeAbasFileSearchResultDto(json: string): AbasFileSearchResultDto {
  const data = JSON.parse(json) as AbasFileSearchResultDto;
  initAbasFileSearchResultDto(data);
  return data;
}
export function initAbasFileSearchResultDto(_data: AbasFileSearchResultDto) {
    return _data;
}
export function serializeAbasFileSearchResultDto(_data: AbasFileSearchResultDto | undefined) {
  if (_data) {
    _data = prepareSerializeAbasFileSearchResultDto(_data as AbasFileSearchResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasFileSearchResultDto(_data: AbasFileSearchResultDto): AbasFileSearchResultDto {
  const data: Record<string, any> = { ..._data };
  return data as AbasFileSearchResultDto;
}
export interface ValidationDto  {
  i: number;
  date: Date;
}
export function deserializeValidationDto(json: string): ValidationDto {
  const data = JSON.parse(json) as ValidationDto;
  initValidationDto(data);
  return data;
}
export function initValidationDto(_data: ValidationDto) {
  if (_data) {
    _data.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
  }
  return _data;
}
export function serializeValidationDto(_data: ValidationDto | undefined) {
  if (_data) {
    _data = prepareSerializeValidationDto(_data as ValidationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeValidationDto(_data: ValidationDto): ValidationDto {
  const data: Record<string, any> = { ..._data };
  data["date"] = _data.date && _data.date.toISOString();
  return data as ValidationDto;
}
export interface AbasUsersSynchronizerJobSettings extends HangFireJobSettings  {
  transferAllUsers: boolean;
  enableSendingWelcomeEmails: boolean;
  dryRun: boolean;
  importUsersCreatedInAbasAfter: Date | null;
}
export function deserializeAbasUsersSynchronizerJobSettings(json: string): AbasUsersSynchronizerJobSettings {
  const data = JSON.parse(json) as AbasUsersSynchronizerJobSettings;
  initAbasUsersSynchronizerJobSettings(data);
  return data;
}
export function initAbasUsersSynchronizerJobSettings(_data: AbasUsersSynchronizerJobSettings) {
  initHangFireJobSettings(_data);
  if (_data) {
    _data.importUsersCreatedInAbasAfter = _data["importUsersCreatedInAbasAfter"] ? new Date(_data["importUsersCreatedInAbasAfter"].toString()) : <any>null;
  }
  return _data;
}
export function serializeAbasUsersSynchronizerJobSettings(_data: AbasUsersSynchronizerJobSettings | undefined) {
  if (_data) {
    _data = prepareSerializeAbasUsersSynchronizerJobSettings(_data as AbasUsersSynchronizerJobSettings);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbasUsersSynchronizerJobSettings(_data: AbasUsersSynchronizerJobSettings): AbasUsersSynchronizerJobSettings {
  const data = prepareSerializeHangFireJobSettings(_data as AbasUsersSynchronizerJobSettings) as Record<string, any>;
  data["importUsersCreatedInAbasAfter"] = _data.importUsersCreatedInAbasAfter && _data.importUsersCreatedInAbasAfter.toISOString();
  return data as AbasUsersSynchronizerJobSettings;
}
export function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}
export function parseDateOnly(s: string) {
    const date = new Date(s);
    return new Date(date.getTime() + 
        date.getTimezoneOffset() * 60000);
}
import type { AxiosError } from 'axios'
export interface FileParameter {
    data: any;
    fileName: string;
}
export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}
export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    protected isApiException = true;
    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}
export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
//-----/Types.File-----